/**
 * Archivo de localización: FR
 * Míster 11 - Sistema de Localización Canónico
 */

export const fr = {
  "ach.biweekly_fit.desc": "Enregistrez ou battez votre record personnel lors des tests physiques.",
  "ach.biweekly_fit.name": "Évolution Physique",
  "ach.biweekly_iron.desc": "100% de présence pendant 14 jours consécutifs.",
  "ach.biweekly_iron.name": "Joueur de Fer",
  "ach.biweekly_self_care.desc": "Envoyez votre bilan de bien-être sur au moins 80% des jours.",
  "ach.biweekly_self_care.name": "Habitude Saine",
  "ach.biweekly_strong_mind.desc": "Réalisez 3 tests psychologiques de gestion du stress ou force mentale.",
  "ach.biweekly_strong_mind.name": "Résilience de Compétition",
  "ach.biweekly_teammate.desc": "Confirmez votre présence (RSVP) à tous les événements à l'avance.",
  "ach.biweekly_teammate.name": "Engagement Collectif",
  "ach.gold_cone_memory.desc": "Mémorisez et reproduisez une séquence d'au moins 6 cônes dans Mémoire de Cônes.",
  "ach.gold_cone_memory.name": "Mémoire de Championnat",
  "ach.gold_impulse_brake.desc": "Atteignez 90% de précision ou plus au jeu Frein Impulsif.",
  "ach.gold_impulse_brake.name": "Frein d'Or",
  "ach.gold_tactical_eye.desc": "Réussissez un 5/5 dans Œil Tactique en trouvant le coéquipier démarqué.",
  "ach.gold_tactical_eye.name": "Œil de Faucon",
  "ach.season_analyst.desc": "Complétez tous les questionnaires et évaluations du catalogue.",
  "ach.season_analyst.name": "Maître Tactique & Mental",
  "ach.season_assist.desc": "Délivrez des passes décisives à vos coéquipiers.",
  "ach.season_assist.name": "Moteur de l'Équipe",
  "ach.season_captain.desc": "100% d'assiduité aux entraînements et aux matchs pendant un mois complet.",
  "ach.season_captain.name": "Esprit de Capitaine",
  "ach.season_mental_squad.desc": "Succès collectif : l'équipe cumule 20 séances cognitives ou plus.",
  "ach.season_mental_squad.name": "Équipe Mentale",
  "ach.season_scorer.desc": "Atteignez l'objectif de buts marqués en compétition officielle.",
  "ach.season_scorer.name": "Buteur de la Saison",
  "ach.season_unstoppable.desc": "Maintenez une série active de 21 jours de régularité sportive.",
  "ach.season_unstoppable.name": "Série Imbattable",
  "ach.season_veteran.desc": "Participez ou soyez convoqué à au moins 80% des matchs de la saison.",
  "ach.season_veteran.name": "Vétéran de la Saison",
  "ach.weekly_attentive.desc": "Consultez les détails du prochain match ou entraînement avant la convocation.",
  "ach.weekly_attentive.name": "Toujours Attentif",
  "ach.weekly_committed.desc": "Réalisez les exercices de votre programme individuel assigné.",
  "ach.weekly_committed.name": "Travail de l'Ombre",
  "ach.weekly_mind_active.desc": "Complétez au moins 3 séances d'entraînement cognitif ou défis cette semaine.",
  "ach.weekly_mind_active.name": "Esprit Actif",
  "ach.weekly_perfect_week.desc": "Participez à 100% des séances d'entraînement prévues cette semaine.",
  "ach.weekly_perfect_week.name": "Semaine Parfaite",
  "ach.weekly_scholar.desc": "Complétez au moins 1 test psychologique ou évaluation sur le portail.",
  "ach.weekly_scholar.name": "Esprit Fort",
  "ach.weekly_wellness.desc": "Enregistrez votre sommeil et votre fatigue les jours d'entraînement.",
  "ach.weekly_wellness.name": "Bilan Santé",
  "ach.weekly_zen.desc": "Pratiquez la Respiration 4-4 sur au moins 3 jours différents dans la semaine.",
  "ach.weekly_zen.name": "Zen",
  "achievements.toast_unlocked": "Succès débloqué : {name} ! (+{xp} XP)",
  "admin.account_deleted": "Your entraîneur compte et données have been supprimé successfully.",
  "admin.ai.desc": "Configurez la clé d'API Groq pour que l'IA Générative fonctionne sur tous les appareils (y compris l'APK tablette sans recompiler).",
  "admin.ai.keyLabel": "Clé API Groq (gsk_...)",
  "admin.ai.saveKey": "ENREGISTRER LA CLÉ",
  "admin.ai.title": "Configuration de l'IA (Groq)",
  "admin.already_latest": "✅ Vous disposez déjà de la dernière version installée (v{version}).",
  "admin.apk.desc": "Installez Mister11 directement sur votre tablette Android",
  "admin.apk.downloadBtn": "TÉLÉCHARGER L'APK",
  "admin.apk.instructions": "Android uniquement · Activez les 'Sources inconnues' dans les paramètres système avant d'installer",
  "admin.apk.title": "Application Android (APK)",
  "admin.apk_download_done": "✅ Télécharger complete. Find the file in your Downloads folder and install it.",
  "admin.apk_download_fallback": "⚠️ Direct télécharger failed. Opening alternative link...",
  "admin.apk_download_start": "⬇️ Starting APK télécharger...",
  "admin.backup_error": "Erreur generating Retourup.",
  "admin.groq_api_error": "Error saving API key à Firestore.",
  "admin.groq_api_saved": "Clé API Groq enregistrée avec succès !",
  "admin.lang.title": "Langue du Système",
  "admin.manageSubAndroidMsg": "Gérez votre abonnement depuis mister11.app",
  "admin.match_not_found": "Match non trouvé.",
  "admin.no_active_team": "Aucune équipe active sélectionnée.",
  "admin.no_players": "Aucun joueur dans l'équipe active.",
  "admin.notif.title": "Notificaciones",
  "admin.pref.checkUpdates": "Rechercher des mises à jour",
  "admin.pref.checking": "Vérification...",
  "admin.pref.darkMode": "Mode Sombre",
  "admin.pref.reminders": "Rappels de Séance",
  "admin.pref.remindersDescApk": "Disponible sur l'application Android (APK).",
  "admin.pref.remindersDescNative": "Vous recevrez une notification 1 heure avant chaque séance d'entraînement.",
  "admin.pref.systemLang": "LANGUE DU SYSTÈME",
  "admin.pref.title": "Préférences",
  "admin.pref.version": "Version actuelle de l'application",
  "admin.profile_error": "Error saving profil.",
  "admin.profile_synced": "Coach profil synced across le entire system.",
  "admin.report_error": "Erreur generating global Rapport.",
  "admin.section.equipos": "Équipe Management",
  "admin.select_match_first": "Please sélectionner un match first.",
  "admin.select_session_first": "Sélectionnez une séance d’abord.",
  "admin.select_team_first": "Sélectionnez une équipe d’abord.",
  "admin.session_not_found": "Séance not found.",
  "admin.settings.category": "CATÉGORIE",
  "admin.settings.coachProfile": "Profil de l'Entraîneur",
  "admin.settings.cookies": "Cookies",
  "admin.settings.copyConsentBtn": "🔗 Copier le Lien de Consentement Numérique",
  "admin.settings.deleteAccountGdpr": "Supprimer Compte et Données (RGPD)",
  "admin.settings.downloadConsentBtn": "Télécharger l'Autorisation Parentale (Imprimable)",
  "admin.settings.fullName": "Nom Complet",
  "admin.settings.inviteStaffBtn": "Copier / Partager le Lien d'Invitation du Staff",
  "admin.settings.legalDesc": "Téléchargez les modèles légaux obligatoires et gérez le consentement éclairé pour les parents de vos joueurs mineurs.",
  "admin.settings.legalTitle": "Centre Légal et Consentements",
  "admin.settings.manageStaffBtn": "Voir et Gérer Tout le Staff Technique",
  "admin.settings.primaryColor": "COULEUR PRINCIPALE",
  "admin.settings.privacy": "Confidentialité",
  "admin.settings.roleAnalyst": "Analyste Tactique",
  "admin.settings.roleAssistant3": "Adjoint / 3e Entraîneur",
  "admin.settings.roleAssistantCoach": "Entraîneur Adjoint",
  "admin.settings.roleFitnessCoach": "Préparateur Physique",
  "admin.settings.roleHeadCoach": "Entraîneur Principal (Admin)",
  "admin.settings.rolePhysio": "Kinésithérapeute / Médecin",
  "admin.settings.rolePlayer": "Joueur",
  "admin.settings.roleSpecialty": "Rôle / Spécialité dans l'Équipe",
  "admin.settings.saveIdentity": "ENREGISTRER L'Identité",
  "admin.settings.saveProfile": "ENREGISTRER Profil et Rôle",
  "admin.settings.season": "SAISON",
  "admin.settings.secondaryColor": "COULEUR SECONDAIRE",
  "admin.settings.subtitle": "Personnalisez votre expérience et l'identité visuelle de votre club.",
  "admin.settings.teamBadge": "ÉCUSSON DE L'ÉQUIPE",
  "admin.settings.teamIdentity": "Identité de l'Équipe",
  "admin.settings.teamName": "NOM DE L'ÉQUIPE",
  "admin.settings.terms": "Conditions",
  "admin.settings.title": "Paramètres du Système",
  "admin.settings.uploadImage": "Téléverser Image",
  "admin.shield_error": "Could not upload ou process le image.",
  "admin.shield_saved": "Écusson enregistré et optimisé avec succès !",
  "admin.svg_shield_saved": "Écusson vectoriel SVG enregistré avec succès !",
  "admin.tab.ajustes": "Paramètres",
  "admin.tab.club": "Club",
  "admin.tab.ejercicios": "Exercices",
  "admin.tab.equipos": "Équipes",
  "admin.tab.exportar": "Exporter",
  "admin.tab.general": "General",
  "admin.tab.suscripcion": "Abonnement",
  "admin.team_identity_error": "Error updating équipe identity.",
  "admin.team_identity_updated": "Équipe identity updated successfully.",
  "admin.theme.dark": "Modo Oscuro",
  "admin.title": "Panneau d'Administration",
  "admin.update_check_error": "Could not check pour updates.",
  "admin.update_connect_error": "Error connecting à le server.",
  "admin.xp.absent": "XP Absent",
  "admin.xp.desc": "Configurez les points d'XP attribués par statut de présence confirmé et les objectifs de saison de l'équipe.",
  "admin.xp.excused": "XP Justifié",
  "admin.xp.goals": "Objectif Buts de la Saison",
  "admin.xp.late": "XP En retard",
  "admin.xp.present": "XP Présent",
  "admin.xp.saveBtn": "Configuration XP",
  "admin.xp.title": "Saison et Tableau d'XP Différencié",
  "admin.xp.veteran": "% Matchs Vétéran",
  "admin.xp_error": "Erreur saving XP configuration.",
  "admin.xp_saved": "XP table et season objectives enregistré successfully.",
  "analisis.btnExportPdf": "Exporter Analysis PDF",
  "analisis.chart.axisCounterEff": "Contre Efficiency",
  "analisis.chart.axisDuels": "% Duelos",
  "analisis.chart.axisLossControl": "Contrôle des Pertes",
  "analisis.chart.axisRecoveries": "Recuperaciones",
  "analisis.chart.axisShots": "Tiros a Puerta",
  "analisis.chart.bars": "Comparatif Direct d'Événements",
  "analisis.chart.duels": "% Duelos Ganados",
  "analisis.chart.losses": "Pertes",
  "analisis.chart.radar": "Radar de Profil Tactique Moyen",
  "analisis.chart.recoveries": "Recuperaciones",
  "analisis.chart.shotsOwn": "Tiros Propios",
  "analisis.chart.shotsOwnTitle": "Own Shots sur Target",
  "analisis.chart.shotsRival": "Tiros Rival",
  "analisis.chart.trend": "Performance Evolution et Trend",
  "analisis.exportPdf": "Télécharger PDF Analysis",
  "analisis.exportingPdf": "Generando PDF...",
  "analisis.kpi.counters": "Contreattack Efficiency",
  "analisis.kpi.countersSub": "Taux de conversion des récupérations",
  "analisis.kpi.duels": "Duelos Ganados",
  "analisis.kpi.duelsSub": "Efficacité globale dans les duels",
  "analisis.kpi.recLossSubAvg": "Moyenne Rec / Pertes",
  "analisis.kpi.recLossSubTot": "Total Rec / Pertes",
  "analisis.kpi.recoveries": "Récupérations / Pertes",
  "analisis.kpi.recoveriesSub": "Moyenne Rec / Pertes",
  "analisis.kpi.recoveriesSubTotal": "Total Rec / Pertes",
  "analisis.kpi.shots": "Tiros a Puerta",
  "analisis.kpi.shotsSub": "Prom. Propio vs Rival",
  "analisis.kpi.shotsSubAvg": "Prom. Propio vs Rival",
  "analisis.kpi.shotsSubTot": "Total Propio vs Rival",
  "analisis.kpi.shotsSubTotal": "Total Propio vs Rival",
  "analisis.loadingData": "Chargement Match events...",
  "analisis.modal.all": "Todos",
  "analisis.modal.clear": "Limpiar",
  "analisis.modal.confirm": "ACEPTAR Y COMPARAR",
  "analisis.modal.noDate": "Sin fecha",
  "analisis.modal.pending": "Pendiente",
  "analisis.modal.selectedCount": "{count} matchs selected",
  "analisis.modal.title": "Select Matchs to Compare",
  "analisis.modal.withData": "Avec données",
  "analisis.mode.averages": "Promedios",
  "analisis.mode.title": "Métriques :",
  "analisis.mode.totals": "Totales",
  "analisis.noMatchesSelected": "Select à least 1 match à perform comparative analysis",
  "analisis.selectMatches": "Select Matchs",
  "analisis.shortcuts.allSeason": "Toute la Saison",
  "analisis.shortcuts.last3": "3 Derniers",
  "analisis.shortcuts.last5": "5 Derniers",
  "analisis.shortcuts.title": "ATAJOS:",
  "analisis.subtitle": "Tactical evolution, shots, duels et recoveries throughout le season",
  "analisis.table.cards": "Tarjetas (A / R)",
  "analisis.table.duels": "Duelos %",
  "analisis.table.fouls": "Faltas (F / C)",
  "analisis.table.match": "Match / Adversaire",
  "analisis.table.recLoss": "Réc / Pert",
  "analisis.table.result": "Resultado",
  "analisis.table.shots": "Tiros (P / R)",
  "analisis.table.title": "Détail par Rencontre",
  "analisis.title": "Analyse de Performance et Vidéo",
  "app.copyright": "2026 Mister11 · {slogan}",
  "app.slogan": "Le bench dans your pocket",
  "attendance.banner.closeMatchSheet": "Fermer Feuille Match",
  "attendance.banner.completeSession": "📋 Compléter Séance",
  "attendance.banner.unclosedEvents": "Vous avez {sessions} séance{sPlural} non enregistrée{sPlural} et {matches} match{mPlural} avec feuille ouverte.",
  "attendance.banner.unclosedSubtitle": "Complétez et fermez pour officialiser les % de présence et les minutes des joueurs.",
  "attendance.btn.exportPdf": "📄 Exporter PDF",
  "attendance.callup.activeWindow": "Fenêtre d'Évaluation Active",
  "attendance.callup.consider": "À Évaluer",
  "attendance.callup.notRecommended": "Non recommandé",
  "attendance.callup.recommended": "Recommandé",
  "attendance.callup.subtitle": "Métriques de présence réelle sur séances programmées pour guider votre prochaine convocation.",
  "attendance.callup.thBreakdown": "Détail (P / R / J / A / NE)",
  "attendance.callup.thGuidance": "Orientation",
  "attendance.callup.thPct": "% Fenêtre",
  "attendance.callup.thPlayer": "Joueur",
  "attendance.callup.thStreak": "🔥 Série",
  "attendance.callup.title": "🎯 Assistant de Convocation par Présence",
  "attendance.callup.window.biweekly": "14 Derniers Jours",
  "attendance.callup.window.microcycle": "Microcycle",
  "attendance.callup.window.season": "Saison",
  "attendance.callup.window.week": "Semaine",
  "attendance.chart.filtersTitle": "Séries du Graphique et Explication (Cliquer pour Afficher/Masquer)",
  "attendance.chart.guide.example": "Currently your équipe averages {avg}% attendance across {count} recorded events.",
  "attendance.chart.guide.step1": "1. Each point is un entraînement ou match: ordered chronologically.",
  "attendance.chart.guide.step2": "2. Le green line is your attendance: above 70% you are sur track.",
  "attendance.chart.guide.step3": "3. If red rises while green drops: there is un commitment issue à address.",
  "attendance.chart.guide.step4": "4. Tap any point à view details et open its register directly.",
  "attendance.chart.guide.title": "Comment interpréter ce graphique ?",
  "attendance.chart.guideCoach": "Guide d'interprétation pour le staff technique",
  "attendance.chart.guideStep1": "1. Points et Chronologie",
  "attendance.chart.guideStep2": "2. Ligne Verte",
  "attendance.chart.guideStep3": "3. Croisement d'Alerte",
  "attendance.chart.guideStep4": "4. Touchez pour le détail",
  "attendance.chart.legend.absent": "Ausentes",
  "attendance.chart.legend.absent.desc": "Unexcused absences. Should aim pour zero.",
  "attendance.chart.legend.attendance": "Présence Réelle (P+R)",
  "attendance.chart.legend.attendance.desc": "Joueurs who attended (present + late). The higher, the better.",
  "attendance.chart.legend.justified": "Justificados",
  "attendance.chart.legend.justified.desc": "Justified notices. Does not penalize le main %.",
  "attendance.chart.legend.late": "Tardes",
  "attendance.chart.legend.late.desc": "Llegadas tarde. Vigila si sube varias semanas seguidas.",
  "attendance.chart.legend.official": "Official (closed sheet/séance)",
  "attendance.chart.legend.provisional": "Provisional (open sheet/séance)",
  "attendance.chart.legend.threshold70": "Seuil d'alerte (70%) : en dessous, risque pour la convocation.",
  "attendance.chart.noData": "Aucune séance ni aucun match enregistré pour le moment.",
  "attendance.chart.openRegister": "Ouvrir le Registre de Présence",
  "attendance.chart.summaryStats": "SélectionneRouge Event Résumé",
  "attendance.chart.title": "Équipe Attendance Evolution",
  "attendance.markAllPresent": "Marquer Tous Présents",
  "attendance.register.closingSheet": "Clôture de la Feuille...",
  "attendance.register.customNew": "+ Nouvelle Date de Présence Personnalisée",
  "attendance.register.date": "Date",
  "attendance.register.excludeTitle": "Exclut cette séance du calcul des présences de tout l'effectif",
  "attendance.register.expected": "⚽ Attendus : {attended} sur {total}",
  "attendance.register.extraSession": "Séance Supplémentaire",
  "attendance.register.futureSession": "🕐 Séance future",
  "attendance.register.markAllPresent": "Marquer Tous Présents",
  "attendance.register.markSuspended": "Marquer Suspendue",
  "attendance.register.matchSheetClosed": "📋 Feuille Officielle Fermée",
  "attendance.register.matchSheetOpen": "⏳ Feuille Ouverte",
  "attendance.register.officialNote": "✅ Officiel · confirmé par le staff",
  "attendance.register.officialSaved": "✅ Enregistrement officiel sauvegardé",
  "attendance.register.pendingRegistration": "⏳ En attente d'enregistrement",
  "attendance.register.prefillRsvp": "⚡ Pré-remplir depuis RSVP",
  "attendance.register.prefillTooltip": "Pré-remplir à partir des réponses des joueurs sans écraser les modifications manuelles",
  "attendance.register.provisionalNote": "⏳ Provisoire · selon réponse du joueur (toucher pour confirmer)",
  "attendance.register.reopenSheet": "🔓 Rouvrir Feuille",
  "attendance.register.rsvpLiveTitle": "📲 Réponses RSVP du Joueur et Planification (en direct)",
  "attendance.register.saveAndCloseSheet": "Enregistrer et Fermer Feuille",
  "attendance.register.saveAttendance": "Enregistrer Présence",
  "attendance.register.selectEvent": "Sélectionner Séance d'Entraînement ou Match :",
  "attendance.register.sessionsAndMatches": "Séances et Matchs",
  "attendance.register.suspendedActive": "Suspendue (Actif)",
  "attendance.register.suspendedSession": "🌧️ Séance Suspendue",
  "attendance.register.title": "Titre",
  "attendance.register.updateNotice": "ℹ️ Vous pouvez modifier l'appel à tout moment ; mise à jour immédiate",
  "attendance.rsvp.going": "Sera présent",
  "attendance.rsvp.justified": "Justifié",
  "attendance.rsvp.late": "Arrivera en retard",
  "attendance.rsvp.none": "Sans réponse",
  "attendance.rsvp.not_going": "Ne viendra pas",
  "attendance.saveBtn": "Enregistrer Attendance",
  "attendance.saveError": "Erreur saving attendance. Please try again.",
  "attendance.saveSuccess": "Attendance enregistré successfully.",
  "attendance.saving": "Enregistrement...",
  "attendance.status.absent": "Absent",
  "attendance.status.injured": "Blessé",
  "attendance.status.justified": "Justifié",
  "attendance.status.late": "En retard",
  "attendance.status.present": "Présent",
  "attendance.status.unmarked": "Non enregistré",
  "attendance.summary.acceptable": "✓ Acceptable",
  "attendance.summary.noData": "⚪ Sans données",
  "attendance.summary.optimal": "✓ Optimal",
  "attendance.summary.risk": "⚠️ Risque",
  "attendance.summary.sortBy": "Trier par :",
  "attendance.summary.sortName": "Nom",
  "attendance.summary.sortNumber": "Numéro",
  "attendance.summary.sortPctAsc": "% Présence (Croissant)",
  "attendance.summary.sortPctDesc": "% Présence (Décroissant)",
  "attendance.summary.thAbsent": "Absent",
  "attendance.summary.thAttendance": "% Présence",
  "attendance.summary.thInjured": "Blessé",
  "attendance.summary.thJustified": "Justif.",
  "attendance.summary.thLate": "Retard",
  "attendance.summary.thNoRecord": "NE",
  "attendance.summary.thPresent": "Présent",
  "attendance.summary.thStatus": "Statut",
  "attendance.summary.threshold": "Seuil d'Alerte :",
  "attendance.summary.title": "👥 Résumé de Présence de l'Effectif ({count} joueurs)",
  "attendance.tab.callup": "🎯 Assistant de Convocation",
  "attendance.tab.register": "📋 Enregistrement par Séance",
  "attendance.tab.summary": "📊 Résumé de l'Effectif",
  "attendance.tab.trend": "📈 Évolution / Graphique",
  "attendance.toast.allMarkedPresent": "Tous marqués comme présents (Officiel)",
  "attendance.toast.errorClosing": "Erreur lors de la clôture de la feuille de match",
  "attendance.toast.errorReopening": "Erreur lors de la réouverture de la feuille de match",
  "attendance.toast.errorSaving": "Erreur lors de l'enregistrement des présences",
  "attendance.toast.noResponses": "Aucun joueur n'a encore répondu",
  "attendance.toast.savedSuccess": "Présences enregistrées avec succès",
  "attendance.toast.selectFirst": "Sélectionnez d'abord une séance ou un match",
  "attendance.toast.sheetClosed": "Feuille de match officielle clôturée et minutes calculées",
  "attendance.toast.sheetReopened": "Feuille de match rouverte pour modification",
  "attendance.toast.suspendedSaved": "Séance marquée comme suspendue et enregistrée",
  "auth.coachRole": "I am Entraîneur / Staff",
  "auth.email": "E-mail",
  "auth.forgotPass": "Mot de passe oublié ?",
  "auth.googleBtn": "Continue avec Google",
  "auth.hasAccount": "Vous avez déjà un compte ?",
  "auth.joinBtn": "Envoyer la Demande",
  "auth.joinTeam": "Rejoindre une équipe",
  "auth.loginBtn": "SE CONNECTER",
  "auth.loginLink": "Se connecter",
  "auth.loginTitle": "Connexion à Mister11",
  "auth.logout": "Cerrar Séance",
  "auth.noAccount": "Vous n'avez pas de compte ?",
  "auth.parentRole": "Soy Padre / Tutor",
  "auth.password": "Mot de passe",
  "auth.playerRole": "I am Joueur",
  "auth.registerLink": "Inscrivez-vous gratuitement",
  "auth.registerTitle": "Créer un Compte",
  "auth.switched_coach": "Switched à Coach Mode",
  "auth.switched_player": "Switched to Joueur Portal",
  "auth.teamCode": "Code d'Invitation (6 chiffres)",
  "block.abp": "Coups de Pied Arrêtés",
  "block.physical": "Physique",
  "block.tactical": "Tactique",
  "block.technical": "Technique",
  "block.warmup": "Échauffement",
  "board.actions.delete": "EFFACER",
  "board.actions.hideRival": "👁 MASQUER ADVERSAIRE",
  "board.actions.showRival": "👁 AFFICHER ADVERSAIRE",
  "board.actions.title": "ACTIONS",
  "board.export.encodingProgress": "Codificando video MP4...",
  "board.export.encodingTitle": "Exportering MP4 Video",
  "board.exportModal.btnCancel": "ANNULER",
  "board.exportModal.btnDownload": "DESCARGAR",
  "board.exportModal.btnExport": "EXPORT",
  "board.exportModal.btnReset": "Restablecer encuadre",
  "board.exportModal.btnShare": "SHARE",
  "board.exportModal.closeModal": "Fermer modal",
  "board.exportModal.completedDesc": "Le file has been processed et enregistré successfully.",
  "board.exportModal.completedTitle": "Exporter Completed!",
  "board.exportModal.exportPath": "Ruta / Destino",
  "board.exportModal.failed": "Error during exporter. Click à retry.",
  "board.exportModal.format": "Exporter Format",
  "board.exportModal.framingTitle": "Cadrage et Aperçu",
  "board.exportModal.landscape": "Horizontal (Paysage)",
  "board.exportModal.loadingPreview": "Chargement animation preview...",
  "board.exportModal.metaDuration": "Durée estimée",
  "board.exportModal.metaSize": "Taille estimée",
  "board.exportModal.metaTitle": "Titre du fichier",
  "board.exportModal.oneFrame": "1 Fotograma",
  "board.exportModal.orientation": "Orientation",
  "board.exportModal.portrait": "Vertical (Mode portrait)",
  "board.exportModal.preparing": "Préparation des images pour le rendu...",
  "board.exportModal.quality": "Qualité / Résolution",
  "board.exportModal.shared": "¡Commatch!",
  "board.exportModal.speed": "Vitesse de Lecture",
  "board.exportModal.subtitle": "Configure exporter parameters et preview frame framing",
  "board.exportModal.title": "Exporter Tactical Animation",
  "board.exportModal.zoomIn": "Acercar",
  "board.exportModal.zoomOut": "Alejar",
  "board.fields.blank": "Tableau Blanc",
  "board.fields.f7": "Football à 7 (65x45m)",
  "board.fields.f8": "Football à 8 (62x46m)",
  "board.fields.full": "Terrain Complet",
  "board.fields.futsal": "Futsal (40x20m)",
  "board.fields.halfAttack": "½ Attaque",
  "board.fields.halfDefense": "½ Défense",
  "board.fields.penaltyArea": "Surface de Réparation",
  "board.fields.reduced": "Terrain Réduit",
  "board.fields.thirdAttack": "Tiers Offensif",
  "board.fields.thirdDefense": "Tiers Défensif",
  "board.fields.thirdMid": "Tiers Médian",
  "board.mat.aro": "Cerceau",
  "board.mat.balon": "Ballon de Football",
  "board.mat.balon_movimiento": "Ballon en Mouvement",
  "board.mat.balon_negro": "Ballon Noir",
  "board.mat.banderin": "Drapeau de Corner",
  "board.mat.cono": "Cône",
  "board.mat.cono_amarillo": "Cône Jaune",
  "board.mat.cono_negro": "Cône Noir",
  "board.mat.cono_rojo": "Cône Rouge",
  "board.mat.escalera": "Échelle d'Agilité",
  "board.mat.flecha_ataque_h": "Flèche Attaque Horizontale",
  "board.mat.flecha_ataque_v": "Flèche Attaque Verticale",
  "board.mat.grupo_balones": "Groupe de Ballons",
  "board.mat.grupo_conos": "Groupe de 3 Cônes",
  "board.mat.grupo_conos_arco": "Arc de 5 Cônes",
  "board.mat.grupo_conos_linea": "Ligne de 5 Cônes",
  "board.mat.indicador_espacio": "Indicateur d'Espace",
  "board.mat.jugador_camiseta": "Jersey Joueur",
  "board.mat.jugador_triangulo": "Triangle Joueur",
  "board.mat.linea_distancia": "Ligne de Distance",
  "board.mat.mini_cono": "Mini Cône",
  "board.mat.pared_rebote": "Mur de Rebond",
  "board.mat.peto": "Chasuble d'Entraînement",
  "board.mat.pica": "Piquet de Slalom",
  "board.mat.platillo": "Coupelle",
  "board.mat.porteria_grande": "Grand But",
  "board.mat.porteria_lateral": "But Latéral",
  "board.mat.porteria_pequena": "Mini But",
  "board.mat.poste": "Mannequin / Poteau",
  "board.mat.valla": "Haie de Saut",
  "board.mat.zona_circular": "Zone Circulaire",
  "board.mat.zona_grid": "Grille 3x3",
  "board.mat.zona_rectangular": "Zone Rectangulaire",
  "board.mat.zona_rombo": "Zone Losange",
  "board.mat.zona_triangular": "Zone Triangulaire",
  "board.matCat.balon": "BALLONS",
  "board.matCat.coordinacion": "COORDINATION",
  "board.matCat.jugadores": "JOUEURS",
  "board.matCat.material": "MATÉRIEL",
  "board.matCat.medidas": "MESURES",
  "board.matCat.porteria": "BUTS",
  "board.matCat.señalizacion": "SIGNALISATION",
  "board.matCat.zonas": "ZONES",
  "board.panels.materials": "Material",
  "board.panels.teams": "Équipes",
  "board.panels.teamsAndFormations": "Équipes & Formations",
  "board.stroke.fine": "Fin",
  "board.stroke.medium": "Moyen",
  "board.stroke.thick": "Épais",
  "board.teams.apply": "APPLIQUER",
  "board.teams.local": "Titulaires",
  "board.teams.rival": "Adversaire",
  "board.teams.title": "ÉQUIPES",
  "board.teams.wildcard": "Joker",
  "board.timeline.addFrame": "Ajouter une image",
  "board.timeline.deleteFrame": "Supprimer frame",
  "board.timeline.export": "Exporter",
  "board.timeline.exportAnimation": "Exporter animation",
  "board.timeline.firstFrame": "Primer fotograma",
  "board.timeline.frameLabel": "Image",
  "board.timeline.lastFrame": "Dernière image",
  "board.timeline.nextFrame": "Siguiente fotograma",
  "board.timeline.play": "Reproducir",
  "board.timeline.playAria": "Lire l'animation",
  "board.timeline.prevFrame": "Fotograma anterior",
  "board.timeline.stop": "Detener",
  "board.timeline.stopAria": "Arrêter la lecture",
  "board.tool.straight_dashed_line": "Ligne droite pointillée",
  "board.tool.zone_hexagon": "Zona hexagonal",
  "board.tool.zone_pentagon": "Zona pentagonal",
  "board.toolbar.clearCanvas": "Effacer entire canvas",
  "board.toolbar.exportMp4": "EXPORTAR MP4",
  "board.toolbar.exportingMp4": "REC... ExporterING MP4",
  "board.toolbar.fieldType": "Type de terrain",
  "board.toolbar.fullscreen": "Plein Écran",
  "board.toolbar.height": "Alto",
  "board.toolbar.new": "NEW",
  "board.toolbar.redo": "Rehacer",
  "board.toolbar.resetZoom": "Reiniciar Zoom",
  "board.toolbar.save": "ENREGISTRER",
  "board.toolbar.sides": "Côtés",
  "board.toolbar.strokeColor": "Couleur du Trait",
  "board.toolbar.strokeWidth": "Épaisseur du Trait",
  "board.toolbar.swapSides": "Inverser les côtés des équipes",
  "board.toolbar.undo": "Deshacer",
  "board.toolbar.width": "Ancho",
  "board.toolbar.zoomIn": "Acercar",
  "board.toolbar.zoomOut": "Alejar",
  "bottomnav.admin": "Admin",
  "bottomnav.ajustes": "Paramètres",
  "bottomnav.equipo": "Équipe",
  "bottomnav.home": "Accueil",
  "bottomnav.ia": "AI",
  "bottomnav.more": "Plus",
  "bottomnav.moreModules": "Modules & Gestion",
  "bottomnav.partidos": "Matchs",
  "bottomnav.pizarra": "Tableau",
  "bottomnav.planificacion": "Planification",
  "bottomnav.sesiones": "Séances",
  "bottomnav.tests": "Tests",
  "btn.add": "AJOUTER",
  "btn.back": "RETOUR",
  "btn.cancel": "ANNULER",
  "btn.close": "FERMER",
  "btn.confirm": "CONFIRMER",
  "btn.delete": "SUPPRIMER",
  "btn.deleteAccount": "Supprimer Account & Data (GDPR)",
  "btn.edit": "MODIFIER",
  "btn.export": "EXPORTER PDF",
  "btn.filter": "FILTRER",
  "btn.save": "ENREGISTRER",
  "btn.search": "RECHERCHER",
  "capture.criteria.downloadPdf": "Télécharger Official PDF",
  "capture.criteria.search": "Rechercher criterion...",
  "capture.criteria.title": "Manuel des Critères de Saisie",
  "capture.hud.advanced": "Avanzado",
  "capture.hud.duel_lost": "Duelo Perdido",
  "capture.hud.duel_won": "Duelo Ganado",
  "capture.hud.foul": "Falta",
  "capture.hud.key_pass": "Pase Clave",
  "capture.hud.recovery": "Récupération",
  "capture.hud.shot": "Tiro",
  "capture.hud.turnover": "Perte de Balle",
  "capture.hud.unattributed": "Sin atribuir",
  "capture.refine_btn": "Affiner l'attribution",
  "capture.refine_empty": "Nothing en attente ✅",
  "capture.refine_prompt_title": "Affiner l'attribution individuelle maintenant ? (facultatif)",
  "capture.refine_skip": "Omitir",
  "capture.refine_subtitle": "Équipe totals are already computed. Assign only what you want to reflect on ratings, radars, and XP.",
  "capture.refine_title": "Affiner l'attribution individuelle (facultatif)",
  "capture.team.shot_own": "Tiro Propio",
  "capture.team.shot_rival": "Tiro Rival",
  "charts.guide.bars": "Quantitative comparison of le 10 key gameplay metrics.",
  "charts.guide.momentum": "Evolution of match dominance et control dans 15-minute intervals.",
  "charts.guide.radar": "Visualizes tactical balance across 6 dimensions between own équipe et opponent.",
  "charts.guide.shots": "Shot distribution et expected goals (xG) probability model.",
  "charts.guide.zones": "Territorial distribution of équipe interventions across 9 pitch zones.",
  "charts.insights.defensive_alert": "Defensive Alert: Opponent generated clear chances avec high shooting comfort.",
  "charts.insights.dominant_zone": "Dominant Zone: Over 40% of actions concentrated dans ce area.",
  "charts.insights.finishing_deficit": "Finishing Efficiency: High volume of scoring chances avec deficit dans conversion vs generated xG.",
  "charts.pass_insufficient_tooltip": "At least 5 recorded passes required à generate tactical pass network.",
  "charts.view.pass_network": "Réseau de Passes",
  "charts.view.territorial_map": "Mapa Territorial",
  "chat.notif_from_player": "💬 Message de {playerName} : \"{msgText}\"",
  "club.team_create_error": "Error creating club équipe.",
  "club.team_created": "Club équipe created successfully.",
  "club.teams_assign_error": "Error assigning équipes.",
  "club.teams_assigned": "Équipes assigned Succèsfully.",
  "cognitive.active_challenges_title": "Défis recommandés actifs & Jeux ({count}) :",
  "cognitive.assign_error": "Erreur saving assignments",
  "cognitive.assigned_success": "✔ {count} recommendation(s) assigned Succèsfully",
  "cognitive.btn_recommend_challenge": "Recommander un défi",
  "cognitive.btn_verified": "✔ Verificado (+5 XP)",
  "cognitive.btn_verifying": "Voirificando…",
  "cognitive.cat.alevin": "U-12",
  "cognitive.cat.benjamin": "U-10",
  "cognitive.cat.cadete": "U-16",
  "cognitive.cat.infantil": "U-14",
  "cognitive.cat.juvenil_adulto": "Juvenil / Adulto",
  "cognitive.category_label": "Catégorie : {cat}",
  "cognitive.delete_recommendation": "Supprimer recommendation",
  "cognitive.deselect_all": "Desmarcar todos",
  "cognitive.game.decision": "Décision 1\"",
  "cognitive.game.freno": "Freno",
  "cognitive.game.memoria": "Memoria",
  "cognitive.game.ojo": "Œil Tactique",
  "cognitive.game.respiracion": "Respiration 4-4",
  "cognitive.game.semaforo": "Feu Tricolore",
  "cognitive.level_by_game_title": "Niveau par Jeu (Mérite Adaptatif)",
  "cognitive.metric_avg_accuracy": "Précision moyenne",
  "cognitive.metric_median_reaction": "Temps de réaction médian",
  "cognitive.metric_sessions_week": "Séances this week",
  "cognitive.metric_trend": "Tendencia",
  "cognitive.modal_assign_title": "⭐ Assign Challenges ou Games",
  "cognitive.modal_cog_games": "🧠 Cognitif Games ({count}/{Total}):",
  "cognitive.modal_confirm_assign": "Confirmer {count} assignment(s)",
  "cognitive.modal_entire_team": "Entire équipe roster",
  "cognitive.modal_home_retos": "⚽ Défis à la Maison ({count}/{total}) :",
  "cognitive.modal_only_player": "Solo {name}",
  "cognitive.modal_recipient_label": "Destinatario:",
  "cognitive.modal_select_min": "Sélectionnez au moins un défi ou jeu",
  "cognitive.recommendation_deleted": "Recommandation supprimée",
  "cognitive.select_all": "Marcar todos",
  "cognitive.supervision_title": "Supervision cognitive & Défis à domicile",
  "cognitive.target_player": "Individual",
  "cognitive.target_team": "Todo el équipe",
  "cognitive.trend_improving": "↑ En progression",
  "cognitive.trend_stable": "= Estable",
  "cognitive.verified_xp": "✔ Challenges verified: +5 XP assigned à {nom}",
  "cognitive.verify_error": "Erreur lors de l'enregistrement de la vérification",
  "cognitive.week_sessions": "Current week · {count} recorded séances",
  "common.absent": "Ausente",
  "common.all": "TOUS",
  "common.away": "Extérieur",
  "common.back": "Retour",
  "common.cancel": "Annuler",
  "common.close": "Fermer",
  "common.closeMenu": "Fermer menu",
  "common.delete": "Supprimer",
  "common.edit": "Modifier",
  "common.email": "E-mail",
  "common.errorGeneral": "Une erreur inattendue est survenue",
  "common.excused": "Excusé",
  "common.friendly": "Amical",
  "common.genericError": "Erreur d'opération",
  "common.home": "Accueil",
  "common.injured": "Blessé",
  "common.loading": "Chargement...",
  "common.matchTag": "Match",
  "common.myTeam": "Mon Équipe",
  "common.no": "Non",
  "common.noData": "Aucune donnée",
  "common.official": "Officiel",
  "common.optimal": "Optimal",
  "common.originalBadgeEn": "EN original",
  "common.originalBadgeEs": "Original ES",
  "common.originalLanguage": "Langue originale",
  "common.originalLanguageEn": "Langue originale : Anglais",
  "common.originalLanguageEs": "Langue originale : Espagnol",
  "common.player": "Joueur",
  "common.present": "Présent",
  "common.risk": "Risque",
  "common.rival": "Adversaire",
  "common.save": "Enregistrer",
  "common.savedSuccess": "Enregistré avec succès",
  "common.saving": "Enregistrement...",
  "common.sessionTag": "Séance",
  "common.starter": "Titulaire",
  "common.substitute": "Remplaçant",
  "common.success": "Opération terminée avec succès",
  "common.training": "Entraînement",
  "common.yes": "Oui",
  "consent.authAvatar": "Photo ou identifying avatar of le joueur dans line-ups et tactical board",
  "consent.authBiometric": "Anthropometric sheet (height et body weight pour physical monitoring et BMI)",
  "consent.authDob": "Date of birth (Required pour automatic age et category calculation)",
  "consent.authExercises": "Assignment of recovery et individual entraînement plans",
  "consent.authInjuries": "Clinical history of suffered injuries (medical health données - GDPR Art. 9)",
  "consent.authName": "Full nom (Required pour joueur profil)",
  "consent.authPhysicalTests": "Fitness et performance physical test results",
  "consent.authPosition": "Sport position et assigned jersey number",
  "consent.authPsychosocial": "Psychosocial questionnaires et daily wellness tests (fatigue, sleep, stress, mood)",
  "consent.authSessions": "Attendance et participation records dans matchs, line-ups et technical reports",
  "consent.clearSig": "Effacer la signature",
  "consent.coachNameLabel": "Head Entraîneur / Responsible",
  "consent.coachNamePlaceholder": "Nom de l'Entraîneur",
  "consent.detailsTitle": "Détails du Consentement",
  "consent.errBasicAuth": "It is mandatory à authorize le processing of nom et date of birth à register le joueur dans le app.",
  "consent.errParentDni": "Guardian ID/Passeport is Requis.",
  "consent.errParentName": "Parent/guardian nom is required.",
  "consent.errPlayerDob": "Joueur date of birth is required.",
  "consent.errPlayerName": "Joueur name (underage) is required.",
  "consent.errSig": "Please draw your digital signature dans le box before proceeding.",
  "consent.footerLegal": "Mister11 does not store your contact données, signature, ou PDF file dans its databases. Le PDF document is processed temporarily et instantly dans le memory of your own mobile/computer browser. Le legal custody of le signed PDF document rests entirely avec le parents/guardians et le entraîneur dans charge of équipe management.",
  "consent.heading": "Consentimiento Parental Digital",
  "consent.instructions": "Fill dans le required information. Fields marked avec (*) are mandatory.",
  "consent.notifyWhatsapp": "Notifier l'entraîneur via WhatsApp",
  "consent.parentDniLabel": "ID / NIE / Passeport *",
  "consent.parentDniPlaceholder": "Ej. 12345678Z",
  "consent.parentNameLabel": "Nom du Tuteur *",
  "consent.parentNamePlaceholder": "Nombre y Apellidos",
  "consent.parentPhoneLabel": "Téléphone de Contact",
  "consent.parentPhonePlaceholder": "Ej. +34 600 000 000",
  "consent.playerDobLabel": "Date de Naissance *",
  "consent.playerNameLabel": "Joueur Name *",
  "consent.playerNamePlaceholder": "Nombre y Apellidos",
  "consent.privacyDesc": "This document has been generated locally. Mister11 does not store copies of your signature ou consent sur its servers. Send le downloaded PDF à le entraîneur via WhatsApp à keep it safely.",
  "consent.privacyTitle": "AVIS DE CONFIDENTIALITÉ",
  "consent.redownloadPdf": "Télécharger PDF Again",
  "consent.relationFather": "Padre",
  "consent.relationGuardian": "Legal Guardian / RePrésentative",
  "consent.relationLabel": "Parentesco *",
  "consent.relationMother": "Madre",
  "consent.seasonLabel": "Saison",
  "consent.sec1": "1. Parent ou Legal Guardian Details",
  "consent.sec2": "2. Underage Joueur Details",
  "consent.sec3": "3. Équipe and Coach Details",
  "consent.sec4": "4. Autorisations relatives aux Données Personnelles",
  "consent.sec4Desc": "Select what données you authorize à be processed dans Mister11 par le coaching staff:",
  "consent.sec5": "5. Déclaration de Consentement Exprès",
  "consent.sec5Text": "Hereby, acting as father, mother ou legal guardian of le underage joueur indicated above, I declare ce I have been transparently informed about le purpose et processing of le sports et wellness données of le joueur sur le Mister11 platform. I grant my express consent à le processing of le boxes checked above.",
  "consent.sec6": "6. Signature Numérique du Tuteur",
  "consent.sigLabel": "Draw your Signature avec Finger ou Mouse *",
  "consent.subTitle": "Informed authorization pour le sports management of le underage joueur.",
  "consent.submitBtn": "Sign et Generate PDF Document",
  "consent.submittingBtn": "Generando PDF firmado...",
  "consent.successDesc": "Le parental consent document pour joueur {nom} has been generated et downloaded à your device successfully.",
  "consent.successTitle": "Succèsfully Signed!",
  "consent.teamNameLabel": "Équipe / Club",
  "consent.teamNamePlaceholder": "Équipe Name",
  "consent.whatsappMsg": "Hello entraîneur, I have already terminé et digitally signed le parental consent pour {nom}. I downloaded le signed PDF à my device. I will partager it avec you next.",
  "convocation.allRecipientsSelected": "Todos seleccionados",
  "convocation.cleanSelection": "Effacer la sélection",
  "convocation.coachLabel": "Entraîneur / ENTRENADOR",
  "convocation.competition": "Compétition",
  "convocation.counter": "{count}/18 SélectionneRouge",
  "convocation.defaultMessage": "Call-up squad pour le match vs {opponent}. Please check le details.",
  "convocation.download": "Télécharger PNG",
  "convocation.downloading": "Descargando...",
  "convocation.generate": "Generar convocatoria PNG",
  "convocation.generatedWith": "Generated avec Mister11",
  "convocation.generating": "Generando PNG...",
  "convocation.limitReached": "Limit reached: maximum 18 joueurs selected",
  "convocation.matchInfo.convocationTime": "Call-up heure (-1h)",
  "convocation.matchInfo.date": "Fecha",
  "convocation.matchInfo.location": "Lugar",
  "convocation.matchInfo.matchTime": "Hora del match",
  "convocation.matchInfo.rival": "Rival",
  "convocation.message": "Message du communiqué",
  "convocation.missingPlayersWarning": "18 joueurs are recommended pour un full squad call-up.",
  "convocation.noMatchSelected": "Aucun match programmé.",
  "convocation.noPlayersSelected": "You have not selected any joueurs.",
  "convocation.positions.def": "DEFENSAS",
  "convocation.positions.fwd": "DELANTEROS",
  "convocation.positions.gk": "PORTEROS",
  "convocation.positions.mid": "MEDIOCAMPISTAS",
  "convocation.positionsEn.def": "DEFENDERS",
  "convocation.positionsEn.fwd": "FORWARDS",
  "convocation.positionsEn.gk": "GOALKEEPERS",
  "convocation.positionsEn.mid": "MIDFIELDERS",
  "convocation.previewTitle": "Aperçu de la Convocation",
  "convocation.quickAccess": "Suivant Match convocation",
  "convocation.regenerate": "Regenerate / Modifier",
  "convocation.round": "Jornada",
  "convocation.selectPlayers": "Select called-up joueurs",
  "convocation.send": "Enviar",
  "convocation.sendError": "Erreur Envoyering convocation.",
  "convocation.sendModalTitle": "Send Convocation to Joueurs",
  "convocation.sendSuccess": "Convocation sent à joueurs successfully.",
  "convocation.sendToPlayers": "Enviar a joueures",
  "convocation.sending": "Enviando...",
  "convocation.tab": "Convocatoria",
  "convocation.title": "Convocation de Match",
  "csv.browseFile": "Seleccionar Archivo",
  "csv.confirmImport": "Confirmer and Importer Joueurs",
  "csv.continueToPreview": "Continue à Preview",
  "csv.downloadTemplate": "Télécharger CSV Template",
  "csv.dropzoneDesc": "Fichiers compatibles : .csv, .xlsx, .xls (max 5 Mo)",
  "csv.dropzoneTitle": "Drag et drop your file here ou click à browse",
  "csv.errorDuplicateNumberFile": "Duplicate shirt number within le file.",
  "csv.errorDuplicateNumberTeam": "Shirt number is already taken dans ce équipe.",
  "csv.errorEmptyFile": "Le selected file is empty.",
  "csv.errorInvalidNumber": "Shirt number must be un integer between 1 et 99.",
  "csv.errorInvalidPosition": "Invalid position. Use GK, DEF, MID, FWD ou equivalent.",
  "csv.errorMissingName": "Joueur name is required.",
  "csv.errorParsing": "Could not read file. Check CSV ou Excel formatting.",
  "csv.errorPlanLimitExceeded": "You have reached le maximum joueurs allowed par your plan.",
  "csv.errorUnsupportedFormat": "Unsupported format. Use .csv ou .xlsx files.",
  "csv.fieldBirthDate": "Date de Naissance",
  "csv.fieldDorsal": "Numéro de Maillot",
  "csv.fieldEmail": "E-mail",
  "csv.fieldOptional": "Opcional",
  "csv.fieldPlayerName": "Joueur Name",
  "csv.fieldPosition": "Poste Principal",
  "csv.fieldRequired": "Requerido",
  "csv.importErrorToast": "Un erreur occurred while importing joueurs.",
  "csv.importSuccessToast": "{count} joueurs imported successfully.",
  "csv.mappingIntro": "Map columns de your spreadsheet à Mister11 fields:",
  "csv.modalTitle": "Importer Joueurs via CSV / Excel",
  "csv.selectColumn": "Sélectionner column...",
  "csv.status": "Estado",
  "csv.stepMapping": "Mapeo",
  "csv.stepPreview": "Vista Previa",
  "csv.stepUpload": "Subir",
  "csv.summaryErrors": "Rows avec errors à fix:",
  "csv.summaryReady": "Joueurs ready for import:",
  "csv.tagValid": "Valide",
  "csv.templateSubtitle": "Télécharger our official CSV template with predefined headers.",
  "csv.templateTitle": "Need un template?",
  "dashboard.activity": "Voici l'activité de votre équipe ({club}) pour cette semaine.",
  "dashboard.devAccess": "Accès Développeur - Mister11 PRO",
  "dashboard.devDesc": "Votre compte bénéficie d'un accès permanent à vie avec toutes les limites levées.",
  "dashboard.devUnlimited": "✔ DÉVELOPPEUR ILLIMITÉ",
  "dashboard.estimatedWorkload": "Charge de Travail Estimée",
  "dashboard.joinAsStaff": "Rejoindre une équipe en tant que Staff",
  "dashboard.noUpcomingSessions": "Aucune séance à venir.",
  "dashboard.period.macro": "Ce macrocycle",
  "dashboard.period.meso": "Ce mésocycle",
  "dashboard.period.micro": "Ce microcycle",
  "dashboard.period.session": "Cette séance",
  "dashboard.period.week": "Cette semaine",
  "dashboard.quickAccess": "Accès Rapide",
  "dashboard.saveDashboard": "ENREGISTRER TABLEAU DE BORD",
  "dashboard.stats.matches": "Matchs",
  "dashboard.stats.noRival": "Aucun adversaire",
  "dashboard.stats.players": "Joueurs",
  "dashboard.stats.rival": "Prochain Adversaire",
  "dashboard.stats.sessions": "Séances",
  "dashboard.teamWorkloadIndex": "Indice de Charge de Travail",
  "dashboard.today": "Aujourd'hui",
  "dashboard.upcomingSessions": "Prochaines Séances",
  "dashboard.upgrade.activatePro": "Activar Modo PRO",
  "dashboard.upgrade.activateProTrial": "Activar Prueba PRO",
  "dashboard.upgrade.freePlanDesc": "Active limits: 1 équipe, 23 joueurs, 10 séances et 5 AI generations per month.",
  "dashboard.upgrade.freePlanTitle": "⭐ Mister11 Free Forfait (Limited)",
  "dashboard.upgrade.planActiveDesc": "You have full access à all features. Thank you pour being part of Mister11 PRO.",
  "dashboard.upgrade.planActiveTitle": "👑 Mister11 {Forfait} · Actif Forfait",
  "dashboard.upgrade.renewAccess": "🔓 RENOUVELER ACCÈS",
  "dashboard.upgrade.resetTrial": "Reiniciar",
  "dashboard.upgrade.subscribe": "⚡ S'ABONNER",
  "dashboard.upgrade.trialActiveDesc": "You have full access à all premium features. You have {days} days ({hours}h) of trial remaining.",
  "dashboard.upgrade.trialActiveTitle": "👑 Mister11 {Forfait} · Free Trial Actif",
  "dashboard.upgrade.trialExpiredDesc": "🔒 Your free trial has ended. Subscribe à restore PRO access.",
  "dashboard.upgrade.trialExpiringDesc": "Only {hours} left of your trial. Subscribe à maintain access.",
  "dashboard.upgrade.trialExpiringTitle": "⚠️ Votre période d'essai expire bientôt !",
  "dashboard.upgrade.tryFree": "Essai Gratuit",
  "dashboard.upgrade.viewPlans": "Voir Forfaits PRO",
  "dashboard.upgrade.viewPlansPro": "👑 VIEW PRO ForfaitS",
  "dashboard.viewAll": "Voir tout",
  "dashboard.weeklyReport.desc": "Summary of trainings et matchs ce week ({séances} séances, {matchs} matchs).",
  "dashboard.weeklyReport.download": "Télécharger PDF",
  "dashboard.weeklyReport.ready": "Votre Rapport Hebdomadaire est prêt !",
  "dashboard.welcome": "Bonjour, {name}",
  "dashboard.workload.week": "Sem",
  "day.Dom": "Dim",
  "day.Jue": "Jeu",
  "day.Lun": "Lun",
  "day.Mar": "Mar",
  "day.Mié": "Mer",
  "day.Sáb": "Sam",
  "day.Vie": "Ven",
  "download.cache_hint": "Enregistré dans le cache. S'il ne s'ouvre pas, cherchez \"{filename}\" dans Fichiers",
  "download.csv_success": "✅ Template ExporteRouge Succèsfully.",
  "download.generic_error": "Erreur lors de l'exportation de la composition",
  "download.image_success": "✅ Image ExporteRouge Succèsfully.",
  "download.json_success": "✅ File ExporteRouge Succèsfully.",
  "download.lineup_downloading": "⬇️ Téléchargement de la composition : {filename}",
  "download.lineup_saved": "✅ Lineup enregistré à {path}",
  "download.lineup_share_dialog": "Enregistrer or share lineup...",
  "download.lineup_share_title": "Mister11 — Composition {team}",
  "download.pdf_error": "Erreur saving PDF",
  "download.pdf_ready": "✅ PDF listo: \"{filename}\"",
  "download.save_error_share_fallback": "⚠️ Could not enregistrer file automatically; please use Share.",
  "download.saved_in": "✅ Enregistré dans : {path}",
  "download.video_success": "✅ Animation exportée avec succès.",
  "equipo.loadingSquad": "Chargement squad...",
  "equipo.publishAnnouncement": "Publier un Communiqué",
  "equipo.tab.attendance": "Présence",
  "equipo.tab.squad": "Effectif",
  "equipo.tab.staff": "Staff Technique",
  "equipo.title": "Gestion de l'Équipe",
  "error.retry_section": "Reintentar",
  "error.section_code": "Code : {code}",
  "error.section_desc": "Un isolated anomaly occurred while rendering ce section. Le rest of le match remains operational.",
  "error.section_unavailable": "Section temporairement indisponible",
  "errors.codeAlreadyUsed": "Ce code a déjà été utilisé.",
  "errors.codeExpired": "Cette invitation a expiré.",
  "errors.codeInvalid": "Code non valide. Il doit comporter 6 caractères.",
  "errors.codeNotFound": "Équipe not found. Verify the code or contact the coach.",
  "exerciseCatalog.categories.cooldown": "Retour au calme",
  "exerciseCatalog.categories.main": "Partie Principale",
  "exerciseCatalog.categories.warmup": "Échauffement",
  "exerciseCatalog.clinicalFallbackNotice": "Source officielle en cours de vérification",
  "exerciseCatalog.phases.fase1": "Phase 1 : Course & Échauffement Dynamique",
  "exerciseCatalog.phases.fase2": "Phase 2 : Force, Pliométrie & Équilibre",
  "exerciseCatalog.phases.fase3": "Phase 3 : Course à Haute Vitesse & Changements de Direction",
  "exerciseCatalog.sourceLabel": "Fuente",
  "exports.gk.claims": "Sorties / Dégagements",
  "exports.gk.cleanSheets": "Clean Sheets",
  "exports.gk.conceded": "Buts Encaissés",
  "exports.gk.errors": "Erreurs",
  "exports.gk.goalkeeper": "Gardien",
  "exports.gk.penaltySaves": "Penaltys Arrêtés",
  "exports.gk.rating": "Note Gardien",
  "exports.gk.savePct": "% Efficacité",
  "exports.gk.saves": "Arrêts",
  "exports.gk.title": "PERFORMANCE DU GARDIEN",
  "exports.report.match_info": "Fiche du Match",
  "exports.report.page": "Page",
  "exports.report.sec10_players": "10. Performance Individuelle et de l'Effectif",
  "exports.report.sec11_swot": "11. Analyse SWOT Tactique et Recommandations",
  "exports.report.sec1_lineup": "1. Composition Tactique avec Photos",
  "exports.report.sec2_timeline": "2. Tableau d'Affichage et Chronologie des Événements",
  "exports.report.sec3_momentum": "3. Momentum et Possession par Tranches de 15'",
  "exports.report.sec4_bars": "4. Barres Comparatives (10 Métriques)",
  "exports.report.sec5_radar": "5. Radar Comparatif (Équipe vs Adversaire)",
  "exports.report.sec6_top5": "6. Top 5 Métriques Différencielles",
  "exports.report.sec7_shots": "7. Cartes des Tirs et Modèle xG-Lite",
  "exports.report.sec8_tactics": "8. Terrain et Tactique (Couloirs, Coups de Pied Arrêtés et Territoire)",
  "exports.report.sec9_gk": "9. Exigence et Performance des Gardiens",
  "exports.report.sec_photos": "Photos et Captures du Match",
  "exports.report.tactical_analysis": "Analyse Tactique",
  "exports.report.title": "RAPPORT OFFICIEL D'APRÈS-MATCH",
  "exports.test.attendance": "Présence",
  "exports.test.mental": "Test Mental / Psychosocial",
  "exports.test.physical": "Test Physique",
  "exports.test.radar_title": "Profil Global de Performance",
  "exports.test.recommendation_title": "Recommandations Individuelles",
  "exports.test.table_interp": "Interprétation",
  "exports.test.table_score": "Score",
  "exports.test.table_test": "Test",
  "exports.test.tactical": "Test Tactique",
  "exports.test.technical": "Test Technique",
  "exports.test.title": "RAPPORT D'ÉVALUATION ET DE TESTS",
  "form.teamName": "Équipe Name",
  "games.assignment.todayPrompt": "Coaching staff has assigned you un special challenge",
  "games.badge.recommended": "Recommended par your entraîneur",
  "games.best.accuracy": "Accuracy: {val}%",
  "games.best.hits": "Aciertos: {val}/5",
  "games.best.maxCones": "Max: {val} cones",
  "games.best.record": "Record: {val} ms",
  "games.btn.backToCatalog": "Retour to Catalog",
  "games.btn.play": "Jugar",
  "games.btn.practiceFirst": "Try dans Practice Mode",
  "games.btn.startOfficial": "Start Séance",
  "games.btn.startReto": "Entrenar",
  "games.disclaimer": "Support cognitive entraînement, not therapy; follow specialist advice pour ADHD.",
  "games.finish.healthyClosing": "Great mental work! Rest your eyes et body.",
  "games.finish.subtitle": "You have terminé le séance avec dedication.",
  "games.finish.title": "Outstanding effort!",
  "games.g1.falseStart": "🚫 False start.",
  "games.g1.skill": "Reaction Speed",
  "games.g1.statBest": "Mejor marca",
  "games.g1.statFalses": "Salidas falso",
  "games.g1.statMedian": "Moyennena",
  "games.g1.step1": "Wait on red.",
  "games.g1.step2": "Tap le screen when it turns GREEN.",
  "games.g1.step3": "Appuyezping earlier = Faux start.",
  "games.g1.tapAreaPrompt": "Appuyez here when it turns GREEN",
  "games.g1.tapNow": "TAP NOW!",
  "games.g1.title": "Pro Traffic Light",
  "games.g1.tooSlow": "Too slow! Miss.",
  "games.g1.waitGreen": "Wait for green…",
  "games.g1.what": "React dans milliseconds: reach le ball before your opponent.",
  "games.g1.why": "Arriving 0.2s earlier à un loose ball changes le play. Reaction can be trained et transfers à runs et interceptions.",
  "games.g2.crMsg": "🛑 Perfect brake!",
  "games.g2.faMsg": "🚫 It was red: you had à brake.",
  "games.g2.missMsg": "⏱️ Green slipped away.",
  "games.g2.prepare": "Watch the cone…",
  "games.g2.skill": "Self-control & Décision",
  "games.g2.statAcc": "Accuracy",
  "games.g2.statFa": "Frenadas fallidas",
  "games.g2.statRt": "Tiempo medio",
  "games.g2.step1": "Un cone appears dans one of le squares.",
  "games.g2.step2": "GREEN → Appuyez it quickly.",
  "games.g2.step3": "Rouge → do NonT Appuyez, brake your finger.",
  "games.g2.title": "Freno Impulsivo",
  "games.g2.what": "Hold Retour impulses: decide before taking action.",
  "games.g2.why": "Most mistakes come de acting hastily. Le \"brake\" improves dribbling, prevents fouls et helps joueurs avec ADHD.",
  "games.g3.hitMsg": "✅ Ouvrir Équipemate found!",
  "games.g3.markedMsg": "❌ That one was marked. Look pour le open one.",
  "games.g3.practiceGuide": "Le open teammate shines dans gold. Tap them!",
  "games.g3.rivalMsg": "😉 That is un opponent. Look pour your teammate.",
  "games.g3.scanPrompt": "Scan avec your eyes…",
  "games.g3.skill": "Visual Scanning & Perception",
  "games.g3.statHits": "Aciertos",
  "games.g3.statRounds": "Rondas",
  "games.g3.statTime": "Tiempo medio",
  "games.g3.step1": "🟢 Équipemates · 🔴 opponents.",
  "games.g3.step2": "Tap le teammate avec le MOST open space.",
  "games.g3.step3": "5 secondes per round.",
  "games.g3.timeOut": "⏱️ Time up. Le open joueur was le clearest.",
  "games.g3.title": "Tactical Eye",
  "games.g3.what": "See le pitch: find le open teammate before receiving.",
  "games.g3.why": "Pros scan 6-8 times every 10 s. Spotting le open joueur before receiving turns un good decision into un great pass.",
  "games.g4.correctMsg": "✅ Perfect sequence!",
  "games.g4.missMsg": "❌ Fermer. Keep trying.",
  "games.g4.repeat": "Repeat le sequence!",
  "games.g4.skill": "Working Memory",
  "games.g4.statMax": "Max sequence",
  "games.g4.statOk": "Rondas acertadas",
  "games.g4.statRange": "Rango",
  "games.g4.step1": "Watch le order dans which le cones light up.",
  "games.g4.step2": "Repeat le sequence par tapping le same cones.",
  "games.g4.step3": "Each round le sequence gets longer.",
  "games.g4.title": "Cone Memory",
  "games.g4.watch": "Watch closely…",
  "games.g4.what": "Remember Information under Appuyezure.",
  "games.g4.why": "Remembering cues et patterns sharpens attention et tactical comprehension: le joueur's \"mental board\".",
  "games.g5.cycleHeader": "Cycle {current} of {Total}",
  "games.g5.exhale": "Exhala",
  "games.g5.exhaleTip": "Release le breath gently through your mouth",
  "games.g5.inhale": "Inhala",
  "games.g5.inhaleTip": "Inhale sFaiblely through your Nonse filling your abdomen",
  "games.g5.skill": "Calma y autocontrol",
  "games.g5.statBenefit": "Beneficio",
  "games.g5.statCycles": "Ciclos",
  "games.g5.statTempo": "Tempo",
  "games.g5.step1": "Circle expands → inhale gently through your Nonse (4 s).",
  "games.g5.step2": "Circle shrinks → exhale sFaiblely through your mouth (4 s).",
  "games.g5.step3": "6 complete cycles, no rush ou scoring.",
  "games.g5.title": "4-4 Breathing",
  "games.g5.what": "Calm nerves before playing.",
  "games.g5.why": "4-4 box breathing activates le parasympathetic system: lowers heart rate et anxiety dans ~1 min. Used par elite athletes; it's simple et done anywhere. That's why we chose it.",
  "games.g5.zenBadge": "6 calm cycles",
  "games.g6.clueGoal": "Goal:",
  "games.g6.clueMate": "Teammate:",
  "games.g6.clueSpace": "Espacio libre:",
  "games.g6.optDribble": "DRIBBLE",
  "games.g6.optPass": "PASS",
  "games.g6.optShoot": "SHOT",
  "games.g6.prompt": "Decide fast!",
  "games.g6.skill": "Tactique Reading",
  "games.g6.statAcc": "Aciertos",
  "games.g6.statPct": "Accuracy",
  "games.g6.statTime": "Tiempo medio",
  "games.g6.step1": "Read le 3 clues sur screen.",
  "games.g6.step2": "But Ouvrir → Tir.",
  "games.g6.step3": "Otherwise, Équipemate Ouvrir → Passe. Else → DRIBBLE (4 s limit).",
  "games.g6.timeOutMsg": "⏱️ Time up. Le best choice was {option}.",
  "games.g6.title": "1-Seconde Décision",
  "games.g6.what": "Pick le best action à un glance: pass, shot ou dribble.",
  "games.g6.why": "Football is played avec le head: deciding fast et well sets great joueurs apart.",
  "games.honesty.pact": "Honesty pact: record your real repetitions. Le effort is yours!",
  "games.intro.howTitle": "How to Play",
  "games.intro.whatTitle": "What We Train",
  "games.intro.whyTitle": "Why It Helps sur le Pitch",
  "games.legend_ceiling": "👑 You reached le Legend ceiling! You are un legend!",
  "games.level_up": "🎉 You leveled up à {level}! {badge} (+10 XP)",
  "games.limits.available": "Disponible",
  "games.limits.cognitiveLbl": "Juegos Cognitivos",
  "games.limits.cognitiveLockedDesc": "You have reached le healthy limit of 15 minutes of cognitive games. Rest your mind à consolidate what you learned!",
  "games.limits.cognitiveLockedTitle": "🧠 Mind trained pour today!",
  "games.limits.completed": "Completado",
  "games.limits.completedToday": "Completed pour today",
  "games.limits.lockedDesc": "You have reached le healthy daily entraînement limit. Come back tomorrow à keep improving.",
  "games.limits.lockedTitle": "Well done pour today!",
  "games.limits.minutesLbl": "Tiempo jugado",
  "games.limits.remainingMin": "Te quedan {count} min hoy",
  "games.limits.remainingTime": "{heure} remaining today",
  "games.limits.retosLbl": "Home Challenges",
  "games.limits.retosLockedDesc": "You have reached your 20 minutes of home challenges pour today. Great physical effort, recover pour le next practice!",
  "games.limits.retosLockedTitle": "⚽ Body et technique trained!",
  "games.limits.sessionsLbl": "Séances today",
  "games.limits.title": "Healthy Entraînement",
  "games.ranking.empty": "Start your entraînement à open le week's podium.",
  "games.ranking.resetInfo": "Réinitialisers every Monday",
  "games.ranking.subtitle": "Un healthy growth space rewarding consistency et personal improvement, not cut-throat rivalry.",
  "games.ranking.tabImproved": "Most Improved",
  "games.ranking.tabPoints": "Puntos Semanales",
  "games.ranking.title": "Ranking Semanal Saludable",
  "games.retos.addRep": "+1 Repetition",
  "games.retos.attemptsExhausted": "Limit of 2 attempts reached pour today. Rest et come back tomorrow!",
  "games.retos.attemptsToday": "intentos hoy",
  "games.retos.btnStart": "Iniciar Reto",
  "games.retos.btnSuperado": "Completado hoy",
  "games.retos.completedBadge": "Superado hoy",
  "games.retos.completedResult": "Completado",
  "games.retos.crp.metric": "Mejor racha",
  "games.retos.crp.skill": "Coordination",
  "games.retos.crp.title": "Cabeza-Rodilla-Pie",
  "games.retos.crp.what": "Head-knee-foot control sequence.",
  "games.retos.cuerda.metric": "Saltos totales",
  "games.retos.cuerda.skill": "Footwork agility et stamina",
  "games.retos.cuerda.title": "Jump Rope",
  "games.retos.cuerda.what": "Foot speed agility et stamina.",
  "games.retos.dom.metric": "Mejor racha",
  "games.retos.dom.skill": "Touch et control",
  "games.retos.dom.title": "Ball Juggling",
  "games.retos.dom.what": "Ball touch et control.",
  "games.retos.eq.metric": "Sets superados",
  "games.retos.eq.skill": "Proprioception",
  "games.retos.eq.title": "Défi d'équilibre",
  "games.retos.eq.what": "Ankle balance et stability.",
  "games.retos.esc.metric": "Sets superados",
  "games.retos.esc.skill": "Foot quickness",
  "games.retos.esc.title": "Agility Ladder",
  "games.retos.esc.what": "Quick footwork et motor speed.",
  "games.retos.finishSet": "Terminar Set ✔",
  "games.retos.lockedBtn": "Locked pour today",
  "games.retos.pared.metric": "Pases totales",
  "games.retos.pared.skill": "Passing et weak foot",
  "games.retos.pared.title": "Wall Passes",
  "games.retos.pared.what": "Accurate passing et non-dominant foot.",
  "games.retos.punt.metric": "Aciertos totales",
  "games.retos.punt.skill": "Passeing accuracy",
  "games.retos.punt.title": "Cone Target",
  "games.retos.punt.what": "Long-Distance Passeing accuracy.",
  "games.retos.questionTimer": "Did you keep up le exercise pour le whole duration?",
  "games.retos.recommendedBadge": "Asignado",
  "games.retos.reg.metric": "Sets superados",
  "games.retos.reg.skill": "Ball handling",
  "games.retos.reg.title": "Dribbling Slalom",
  "games.retos.reg.what": "Dribbling through cones avec pace change.",
  "games.retos.repetitions": "{count} repeticiones",
  "games.retos.setHeader": "Set {current} of {Total}",
  "games.retos.setsWord": "sets",
  "games.retos.startTimer": "Comenzar Tiempo",
  "games.retos.statSets": "Sets",
  "games.retos.statStatus": "Resultado",
  "games.retos.streakEnd": "Ballon tombé / Fin de série",
  "games.retos.timeExhausted": "You have reached le 20-minute daily challenge limit. Great physical effort!",
  "games.retos.touchesStreak": "{count} touches dans un row",
  "games.safety.title": "Safety at Home",
  "games.status.notPlayed": "Sin registro",
  "games.status.practice": "Practice (unScoRouge)",
  "games.tabs.cognitive": "Cognitif Games (6)",
  "games.tabs.retos": "Défis à domicile (8)",
  "games.timer.paused": "Pausado",
  "games.timer.remainingChip": "Remaining today: {heure}",
  "games.timer.setFinishing": "Final set",
  "gk.activeGoalkeeper": "ButGardien ON Terrain",
  "gk.aerialClaim": "Sorties Aériennes",
  "gk.boxDominance": "Domination de la Surface",
  "gk.btn.claim": "Salida / Rechace",
  "gk.btn.conceded": "Gol Encajado",
  "gk.btn.errorGoal": "Error Leading à Goal",
  "gk.btn.penaltySave": "Penalti Parado",
  "gk.btn.save": "Enregistrer",
  "gk.buildup": "Relance et Jeu au Pied",
  "gk.claims": "Salidas y Despejes",
  "gk.claimsShort": "Salidas",
  "gk.cleanSheets": "Clean Sheets",
  "gk.cleanSheetsShort": "Invicto",
  "gk.conceded": "Goals Conceded",
  "gk.concededShort": "Enc.",
  "gk.diveLow": "Plongeon Bas",
  "gk.errorGoal": "Errors Leading à Goal",
  "gk.errorGoalShort": "Err. Gol",
  "gk.events.empty": "No goalkeeping events recorded pour ce match.",
  "gk.events.list": "Butkeeping Events",
  "gk.evolution": "Enregistrer % Evolution",
  "gk.history": "Historial de Matchs",
  "gk.noActiveGoalkeeper": "No actif goalkeeper sur pitch",
  "gk.parrySafe": "Arrêt Sûr / Détourné",
  "gk.penaltySaves": "Penaltis Parados",
  "gk.penaltySavesShort": "Pen. Par.",
  "gk.perMatch": "Por match",
  "gk.rating": "GK Rating",
  "gk.reflexClose": "Réflexes à Bout Portant",
  "gk.role": "Gardien",
  "gk.roleBadge": "🧤 Portero",
  "gk.saveHigh": "Parade Haute",
  "gk.savePercentage": "Enregistrer %",
  "gk.savePercentageShort": "Enregistrer %",
  "gk.saves": "Paradas",
  "gk.savesShort": "Par.",
  "gk.smother": "Sortie dans les Pieds",
  "gk.suggest.confirm": "Yes, assign à goalkeeper",
  "gk.suggest.ignore": "Non, record But only",
  "gk.suggest.message": "Un opponent goal was recorded. Do you want à ajouter 1 conceded goal à le actif goalkeeper ({nom})?",
  "gk.suggest.title": "Assign conceded But?",
  "gk.sweeper": "Gardien Libéro",
  "gk.title": "Métriques Spécifiques Gardien de But",
  "gk.tooltip.claim": "Aerial claim, interception, ou punched clearance.",
  "gk.tooltip.cleanSheet": "Match terminé avec minutes played sans conceding un goal.",
  "gk.tooltip.conceded": "Goal allowed while playing dans goal.",
  "gk.tooltip.errorGoal": "Direct mistake dans possession ou positioning resulting dans un opponent goal.",
  "gk.tooltip.penaltySave": "Penalty kick enregistré during le match.",
  "gk.tooltip.save": "Successful intervention preventing un opponent goal.",
  "header.logoutConfirm": "Do you want à log out ou switch accounts?",
  "header.switchPlayerPortal": "Switch to Joueur Portal",
  "health.active": "Activo",
  "health.addInjury": "+ Record Injury",
  "health.additionalNotes": "Notes Complémentaires",
  "health.affectedArea": "Zone Touchée *",
  "health.cancel": "Annuler",
  "health.injuryDate": "Date de la Blessure *",
  "health.injuryType": "Type de Blessure *",
  "health.markRecovered": "Marquer comme Rétabli",
  "health.medicalNotes": "Observations Médicales",
  "health.medicalNotesPlaceholder": "Allergies, traitements continus, notes médicales...",
  "health.noInjuries": "Non injuries recorded.",
  "health.recordInjury": "Enregistrer une Nouvelle Blessure",
  "health.resolved": "Recuperado",
  "health.saveInjury": "Enregistrer Injury",
  "health.status.active": "Disponible / Actif",
  "health.status.current": "Statut Actuel",
  "health.status.injured": "Blessé",
  "health.status.recovery": "En Récupération",
  "health.status.rest": "Repos",
  "health.title": "Medical History & Injuries",
  "health.updateStatus": "Mettre à Jour le Statut Général",
  "ia.additionalObs": "Ajouteritional observations",
  "ia.age.alevin": "Under-12 (10-12)",
  "ia.age.amateur": "Amateur",
  "ia.age.base": "Grassroots (6-10 years)",
  "ia.age.cadete": "Cadete (14-16)",
  "ia.age.infantil": "Infantil (12-14)",
  "ia.age.juvenil": "Juvenil (16-18)",
  "ia.age.prebenjamin": "Under-10 (8-10)",
  "ia.animation": "Animation ({count}F)",
  "ia.btnClear": "🔄 Limpiar",
  "ia.btnExportPdf": "📄 Exporter PDF",
  "ia.btnGeneratePrevention": "🩺 Generate Exercice Plan",
  "ia.btnGenerateTactical": "✨ Generate Exercice",
  "ia.btnSave": "💾 Enregistrer",
  "ia.capture": "Captura",
  "ia.categoryAge": "CATÉGORIE / ÂGE",
  "ia.defaultTitle": "AI Exercice {time}",
  "ia.dictationNotSupported": "Your browser does not support voice dictation. Use Chrome sur Android pour ce feature.",
  "ia.dictationStart": "Voice dictation",
  "ia.dictationStop": "Detener dictado",
  "ia.drawerTitle": "☁️ Biblioteca Cloud",
  "ia.durationMinutes": "{count} min",
  "ia.emptyLibrary": "No enregistré exercises yet.",
  "ia.emptyPlaceholder": "Votre exercice apparaîtra ici",
  "ia.emptyResponse": "Empty response de AI",
  "ia.intensityLabel": "Intensité",
  "ia.level.advanced": "Avanzado",
  "ia.level.basic": "Basic",
  "ia.level.intermediate": "Intermedio",
  "ia.libraryBtn": "☁️ Bibliothèque ({count})",
  "ia.limitReached": "You have reached le monthly limit of {limit} AI generations. Le limit resets next month.",
  "ia.listening": "🔴 Listening... speak Nonw",
  "ia.loadingAnalyzing": "⏳ Analizando contexto...",
  "ia.loadingGenerating": "Generando...",
  "ia.loadingUsage": "🔑 AI: Chargement usage...",
  "ia.mainObjective": "OBJECTIF PRINCIPAL",
  "ia.mat.balls": "Ballons",
  "ia.mat.bibs": "Chasubles",
  "ia.mat.cones": "Cônes",
  "ia.mat.goals": "Buts",
  "ia.mat.hurdles": "Haies",
  "ia.mat.ladder": "Échelle d'agilité",
  "ia.mat.none": "Non specific equipment",
  "ia.mat.rings": "Aros",
  "ia.materials": "MATÉRIEL",
  "ia.modalDetail": "Detalle",
  "ia.modalLoad": "Cargar",
  "ia.modalNoContent": "Sin contenido.",
  "ia.modalOpenBoard": "Open in Board",
  "ia.modePrevention": "Prévention /\nRécupération",
  "ia.modeTactical": "Exercice\nTactique",
  "ia.noRef": "Sin Ref.",
  "ia.numPlayers": "NB DE JOUEURS : {count}",
  "ia.obj.aerobic": "Aerobic Endurance",
  "ia.obj.agility": "Agilité & Coordination",
  "ia.obj.cooldown": "Retour au calme",
  "ia.obj.crossing": "Centreing & box arrivals",
  "ia.obj.finishing": "Finishing & shooting",
  "ia.obj.positional": "Positional play",
  "ia.obj.possession": "Poséance de balón",
  "ia.obj.pressing": "Appuyezing & Contre-Appuyez",
  "ia.obj.speed": "Vitesse",
  "ia.obj.strength": "Force & Puissance",
  "ia.obj.transAttDef": "Transition attack-à-defense",
  "ia.obj.transDefAtt": "Transition defense-à-attack",
  "ia.obj.warmup": "Échauffement",
  "ia.obsPlaceholder": "E.g. Focus sur execution speed ou defensive transition...",
  "ia.phaseLabel": "Phase de jeu",
  "ia.prev.availableMaterial": "Disponible Equipment",
  "ia.prev.bodyZone": "Zona Corporal",
  "ia.prev.descLabel": "Clinical Description / Problem",
  "ia.prev.descPlaceholder": "E.g.: 16yo joueur avec left hamstring overload post-match, requires eccentric et strengthening exercises...",
  "ia.prev.noMaterial": "Sin material",
  "ia.prev.planType": "Plan Type",
  "ia.prev.playerLevel": "Joueur Level",
  "ia.prev.typePrevention": "Prevention",
  "ia.prev.typeReadaptation": "Readaptation",
  "ia.prev.typeRecovery": "Recovery",
  "ia.recoveryNotice": "Séance axée sur la régénération musculaire et la prévention.",
  "ia.saveError": "Erreur saving Exercice. Please try again.",
  "ia.saveSuccess": "✅ Saved à library: \"{title}\"",
  "ia.selectPlaceholder": "Sélectionner...",
  "ia.space": "Espacio",
  "ia.space.box": "Penalty area",
  "ia.space.full": "Campo completo",
  "ia.space.gym": "Sala / Gimnasio",
  "ia.space.half": "Medio campo",
  "ia.space.small": "Espace réduit",
  "ia.space.threeQuarter": "3/4 campo",
  "ia.subtitle": "CONCEPTION INTELLIGENTE DE SÉANCES D'ENTRAÎNEMENT",
  "ia.tacticalBoard": "🎬 Pizarra",
  "ia.tacticalRef": "Tactique Reference (Optionnel)",
  "ia.title": "Assistant Tactique d'IA",
  "ia.usageRemaining": "🔑 AI: you have {count} uses left ce month (limit {limit})",
  "ia.validationPrevention": "Please describe le case et sélectionner un body zone.",
  "ia.validationTactical": "Please fill dans: Age, Objective, et Pitch Area.",
  "ia.zone.adductors": "Aductores",
  "ia.zone.ankle": "Tobillo",
  "ia.zone.calves": "Gemelos",
  "ia.zone.core": "Core / Pelvis",
  "ia.zone.hamstring": "Isquiotibial",
  "ia.zone.knee": "Rodilla",
  "ia.zone.lumbar": "Lumbar",
  "ia.zone.quadriceps": "Quadriceps",
  "ia.zone.shoulder": "Hombro",
  "install.alreadyInstalled": "Le App is already installed sur your device!",
  "install.androidDesc": "Tap le \"Install now\" button below ou open le three dots menu (⋮) et sélectionner \"Install app\".",
  "install.androidTitle": "Android (Chrome) :",
  "install.btnInstall": "Instalar ahora",
  "install.fallbackNotice": "If you do not see le install button, use le \"Add à Home Screen\" option dans your browser.",
  "install.instructions": "Instrucciones:",
  "install.iosDesc": "Tap le \"Share\" button (square avec arrow) et sélectionner \"Add à Home Screen\".",
  "install.iosTitle": "iOS (Safari):",
  "install.metaDesc": "Step-par-step installation instructions pour Mister11 PWA sur Android et iOS devices.",
  "install.metaTitle": "Install Mister11 — Le Football App pour Coaches",
  "install.slogan": "Le bench dans your pocket",
  "install.title": "Installer l'Application Mister11",
  "invite.already_registered": "This email is already registered ou invited à le club.",
  "invite.coach.codePlaceholder": "Invitation code (6 characters)",
  "invite.coach.scanQR": "Scan invitation QR",
  "invite.coach.title": "Rejoindre comme entraîneur / staff",
  "invite.generated_error": "Error generating le invitation.",
  "invite.generated_success": "Invitation generated Succèsfully.",
  "invite.link_copied": "Link copied!",
  "invite.player.codePlaceholder": "Équipe code",
  "invite.player.scanQR": "Escanear QR del équipe",
  "invite.player.title": "Join Your Équipe",
  "joinTeam.account_created": "Account created Succèsfully",
  "joinTeam.already_member": "You are already sur ce équipe! Loading your portal...",
  "joinTeam.google_sign_in": "Signed dans avec Google",
  "joinTeam.request_approved": "Your request has been approved!",
  "joinTeam.request_sent": "Request sent à le entraîneur!",
  "joinTeam.welcome": "Welcome à Mister11",
  "live.action.foul": "Faute",
  "live.action.goal": "But",
  "live.action.offside": "Hors-jeu",
  "live.action.recovery": "Récupération",
  "live.action.redCard": "Carton Rouge",
  "live.action.shot": "Tir",
  "live.action.turnover": "Perte de balle",
  "live.action.yellowCard": "Carton Jaune",
  "live.btn.card_red_own": "Roja (Propia)",
  "live.btn.card_red_rival": "Rouge Carton (Opponent)",
  "live.btn.card_yellow_own": "YelFaible Carton (Own)",
  "live.btn.card_yellow_rival": "YelFaible Carton (Opponent)",
  "live.btn.corner_against": "Corner Against",
  "live.btn.corner_favor": "Corner in Favor",
  "live.btn.counter_not_cut": "Contra No Cortada",
  "live.btn.duel_lost": "Duelo Perdido",
  "live.btn.duel_won": "Duelo Ganado",
  "live.btn.foul_against": "Foul Against",
  "live.btn.foul_favor": "Falta a Favor",
  "live.btn.loss": "Perte de Balle",
  "live.btn.offside_own": "Offside (Own)",
  "live.btn.offside_rival": "Hors-jeu (Opponent)",
  "live.btn.player_no_finish": "Jugada No Finalizada",
  "live.btn.recovery": "Récupération",
  "live.btn.save_own": "Goalkeeper Enregistrer (Own)",
  "live.btn.save_rival": "Goalkeeper Enregistrer (Opponent)",
  "live.btn.shot_off_own": "Tir off Target (Own)",
  "live.btn.shot_off_rival": "Tir off Target (Opponent)",
  "live.btn.shot_on_own": "Shot sur Target (Own)",
  "live.btn.shot_on_rival": "Shot sur Target (Opponent)",
  "live.tab.analytics": "Advanced Analysis",
  "live.tab.capture": "Live Capture",
  "live.tab.players": "Joueurs & CSV",
  "live.tab.tactical": "Field & Tactics",
  "liveStats.quickMode.advanced": "Advanced Options",
  "liveStats.quickMode.shotSaved": "Tiro registrado",
  "liveStats.quickMode.simple": "Modo simple",
  "liveStats.quickMode.title": "Quick Mode",
  "liveStats.quickMode.undo": "Deshacer",
  "liveStats.quickMode.undone": "Tiro deshecho",
  "livestats.match_locked_short": "⚠️ Match terminé",
  "livestats.match_locked_use_reopen": "⚠️ Match terminé — use Reopen Match Sheet à correct.",
  "livestats.post_match_saved": "✅ Post-match counters enregistré",
  "livestats.select_player_first": "👆 Sélectionnez un joueur d’abord",
  "login.account_created": "Account created Succèsfully!",
  "login.cancelled": "Sign-dans cancelled par user",
  "login.recovery_error": "Erreur Envoyering email",
  "login.recovery_sent": "Recovery link sent à your email",
  "login.welcome": "Welcome à Mister11!",
  "login.write_email_first": "Escribe tu correo primero",
  "match.btn.exportIcs": "EXPORTER ICS",
  "match.btn.newMatch": "+ NOUVEAU MATCH",
  "match.btn.pdfCalendar": "CALENDRIER PDF",
  "match.defaultMyTeam": "Mon Équipe",
  "match.defaultRival": "Adversaire",
  "match.filter.all": "Tous",
  "match.filter.finished": "Terminés",
  "match.filter.pending": "En attente",
  "match.formationLabel": "Formation : ",
  "match.locked_reopen": "⚠️ Match terminé. Reopen match sheet à record events.",
  "match.management.title": "GESTION DES MATCHS",
  "match.noVenue": "Sans lieu",
  "match.sort.cercania": "Plus proche d'aujourd'hui",
  "match.sort.estado": "Par Statut / Priorité",
  "match.sort.fecha_asc": "Date (Prochains)",
  "match.sort.fecha_desc": "Date (Récents)",
  "match.sort.label": "Trier par",
  "match.sort.lejania": "Plus éloigné d'aujourd'hui",
  "match.status.en_edicion": "EN ÉDITION",
  "match.status.finalizado": "TERMINÉ",
  "match.status.no_disputado": "NON DISPUTÉ",
  "match.status.pendiente": "EN ATTENTE",
  "match.venue.local": "Terrain Domicile",
  "match.venue.municipal": "Stade Municipal",
  "match.view.cards": "Cartes",
  "match.view.detailed": "Détaillé",
  "matchSheet.anomalies_resolved": "✔ {count} anomaly(ies) resolved et sheet synchronized.",
  "matchSheet.auto_badge": "Auto",
  "matchSheet.close_error": "❌ Erreur closing Match sheet. Please try again.",
  "matchSheet.closed_success": "✅ Match sheet closed. Real minutes enregistré.",
  "matchSheet.closed_with_warnings": "⚠️ Match sheet closed avec recorded warnings.",
  "matchSheet.confirm_save_btn": "💾 Confirmer & Enregistrer SHEET",
  "matchSheet.confirm_save_tooltip": "Enregistrer all manual minute corrections and update the official match sheet",
  "matchSheet.log_already_clean": "✨ Le match log is already clean. Zero impossible events.",
  "matchSheet.log_debug_error": "❌ Erreur debugging log.",
  "matchSheet.manual_allowed_closed": "Autorisé même lorsque fermé",
  "matchSheet.manual_badge": "Manual",
  "matchSheet.manual_override_title": "Manual Minutes override",
  "matchSheet.prefill_rsvp_empty": "No en attente RSVP responses à pre-fill.",
  "matchSheet.prefill_rsvp_error": "❌ Error pre-filling de RSVP.",
  "matchSheet.prefill_rsvp_success": "✅ Statuses pre-filled de RSVP.",
  "matchSheet.prefill_smart_error": "❌ Error dans smart pre-filling.",
  "matchSheet.prefill_smart_success": "⚡ Match sheet smartly pre-filled de lineup et events.",
  "matchSheet.referee": "Arbitre",
  "matchSheet.reopen_error": "❌ Erreur reOuvriring Match sheet.",
  "matchSheet.reopened_info": "🔓 Match sheet et match reopened pour corrections.",
  "matchSheet.saving": "💾 Guardando...",
  "matchSheet.signatures": "Signatures Officielles",
  "matchSheet.tactical_grade_saved": "⭐ Tactical rating enregistré",
  "matchSheet.weather": "Météo / Terrain",
  "matches.finish_error": "❌ Erreur saving completion:",
  "matches.lineup.benchTitle": "RemplaçantS Banc",
  "matches.lineup.downloadPng": "DESCARGAR PNG",
  "matches.lineup.emptySlot": "Empty",
  "matches.lineup.exportingPng": "EXPORTANDO...",
  "matches.lineup.subtitle": "Tactical board avec starting XI et substitutes bench",
  "matches.lineup.title": "Tactique Lineup & Banc",
  "matches.log_cleanse_error": "❌ Erreur cleansing log.",
  "matches.log_cleansed": "🧹 Log cleansed Succèsfully. {count} records sanitized.",
  "matches.repair_error": "❌ Erreur repairing Match.",
  "matches.repaired": "✅ Match repaired et persisted successfully.",
  "matches.warnings.auditHide": "Hide audit",
  "matches.warnings.auditNote": "Log cleansed sur {date}: {count} anomalies isolated et resolved.",
  "matches.warnings.auditShow": "Voir detalle",
  "matches.warnings.bannerTitle": "This match contained {count} isolated log anomalies ou legacy données.",
  "matches.warnings.chipTooltip": "{count} anomalies detected dans log (click à view et resolve dans Official Sheet)",
  "matches.warnings.cleanseBtn": "Cleanse & Resolve",
  "matches.warnings.cleansing": "Depurando...",
  "matches.warnings.hideDetails": "Ocultar detalles",
  "matches.warnings.resolvedSuccess": "✔ {count} anomaly/anomalies resolved et match sheet synchronized.",
  "matches.warnings.showDetails": "Voir lista",
  "month.Abr": "Avr",
  "month.Ago": "Août",
  "month.Dic": "Déc",
  "month.Ene": "Janv",
  "month.Feb": "Févr",
  "month.Jul": "Juil",
  "month.Jun": "Juin",
  "month.Mar": "Mars",
  "month.May": "Mai",
  "month.Nov": "Nov",
  "month.Oct": "Oct",
  "month.Sep": "Sept",
  "nav.admin": "ADMINISTRATION",
  "nav.dashboard": "TABLEAU DE BORD",
  "nav.equipo": "MON ÉQUIPE",
  "nav.ia": "IA GÉNÉRATIVE",
  "nav.partidos": "MATCHS",
  "nav.pizarra": "TABLEAU TACTIQUE",
  "nav.planificacion": "PLANIFICATION",
  "nav.sesiones": "SÉANCES",
  "nav.tests": "TESTS",
  "notifPrefs.chatDesc": "Alerts pour new messages dans équipe squad chat",
  "notifPrefs.chatTitle": "Équipe Messages",
  "notifPrefs.errorToast": "Erreur saving Nontification preferences",
  "notifPrefs.frequencyCapDesc": "Maximum number of Nontifications per day",
  "notifPrefs.frequencyCapTitle": "Frequency Cap",
  "notifPrefs.matchDesc": "Alertes pour convocations, calendriers et matchs à venir",
  "notifPrefs.matchTitle": "Matchs & Convocations",
  "notifPrefs.perDay": "per day",
  "notifPrefs.quietHoursDesc": "Do not receive push notifications during ce heure window",
  "notifPrefs.quietHoursEnd": "Quiet end time",
  "notifPrefs.quietHoursStart": "Quiet start heure",
  "notifPrefs.quietHoursTitle": "Quiet Hours",
  "notifPrefs.reminderTime": "Heure du rappel",
  "notifPrefs.savedToast": "Notification preferences enregistré successfully",
  "notifPrefs.title": "Préférences de Notification",
  "notifPrefs.wellnessDesc": "Daily reminder à fill out your health form",
  "notifPrefs.wellnessTitle": "Wellness Check-dans",
  "notifications.empty": "Vous n'avez aucune notification en attente.",
  "notifications.individualPlanAssigned": "Plan individuel attribué avec succès",
  "notifications.individualPlanRemoved": "Plan individuel supprimé",
  "notifications.newExerciseSaved": "Nouvel exercice enregistré : {name}",
  "notifications.newMatchRegistered": "Nouveau match enregistré contre {opponent}",
  "notifications.newPlayerAdded": "Nouveau joueur ajouté : {name}",
  "notifications.newSessionCreated": "Nouvelle séance créée : {title}",
  "notifications.predefinedExerciseError": "Vous ne pouvez pas supprimer un exercice prédéfini du système.",
  "notifications.sessionImportedSuccess": "Séance \"{title}\" imported successfully",
  "notifications.teamPlanAssigned": "Plan d'équipe attribué avec succès",
  "notifications.teamPlanRemoved": "Plan d'équipe supprimé",
  "notifications.timeHoursAgo": "Il y a {hours} heures",
  "notifications.timeJustNow": "À l'instant",
  "notifications.timeMinAgo": "Il y a {min} min",
  "notifications.timeNow": "Maintenant",
  "notifications.title": "Notificaciones",
  "notifications.weeklyReportReady": "📋 Your weekly team report is ready. Télécharger it from the main panel!",
  "page.admin": "ADMINISTRATION",
  "page.dashboard": "TABLEAU DE BORD",
  "page.default": "Mister11",
  "page.equipo": "MON ÉQUIPE",
  "page.ia": "IA GÉNÉRATIVE",
  "page.partidos": "MATCHS",
  "page.pizarra": "TABLEAU TACTIQUE",
  "page.planificacion": "PLANIFICATION",
  "page.sesiones": "SÉANCES",
  "page.tests": "TESTS",
  "partidos.tab.analisis": "Analyse",
  "partidos.tab.lista": "Matchs",
  "paywall.androidBackToInfo": "Retour",
  "paywall.androidDialogText": "Subscriptions are centrally managed sur our web platform. Visit mister11.app à purchase your plan et get instant access dans ce app.",
  "paywall.androidDialogTitle": "Forfaits Mister11 PRO",
  "paywall.androidHaveCode": "I already have un code",
  "paywall.androidNotNow": "Pas maintenant",
  "paywall.androidOpenWeb": "Ouvrir mister11.app",
  "paywall.androidRedeemDesc": "Enter your corporate ou promotional code à activate your PRO plan instantly.",
  "paywall.androidRedeemTitle": "Utiliser un Code",
  "paywall.benefit1": "Unlimited entraînement séances",
  "paywall.benefit2": "Générateur de tâches IA illimité",
  "paywall.benefit3": "Exporter technical reports in PDF",
  "paywall.benefit4": "Advanced statistics et metrics suite",
  "paywall.clubBadge": "FORFAIT CLUB",
  "paywall.freeLimitMsg": "You have reached le free plan limit.",
  "paywall.proBadge": "FORFAIT PRO",
  "paywall.promoPlaceholder": "Code (e.g. BETA2026)",
  "paywall.promoSectionDesc": "Enter your code (e.g. BETA2026) à activate access immediately.",
  "paywall.promoSectionTitle": "🔑 Avez-vous un code promotionnel ou d'essai bêta ?",
  "paywall.title": "Débloquez Mister11 Pro",
  "paywall.upgradeBtn": "OBTENIR LE PLAN PRO",
  "paywall.upgradeClubBtn": "Voir Forfaits CLUB",
  "placeholder.teamName": "e.g. Manchester Youth Un",
  "plan.category": "CATÉGORIE",
  "plan.categoryPlaceholder": "Ex. : U14 A",
  "plan.chip.compet": "Compét.",
  "plan.chip.sessions": "Séances",
  "plan.chip.work": "Travail",
  "plan.coach": "ENTRAÎNEUR",
  "plan.coachPlaceholder": "Nom de l'entraîneur",
  "plan.dateRange": "PLAGE DE DATES",
  "plan.days.friday": "F",
  "plan.days.monday": "M",
  "plan.days.saturday": "S",
  "plan.days.sunday": "S",
  "plan.days.thursday": "T",
  "plan.days.tuesday": "T",
  "plan.days.wednesday": "W",
  "plan.end": "Fin",
  "plan.exportPdf": "EXPORTER PDF",
  "plan.fatigaWarning": "⚠️ Entraînement en J-1 — fatigue potentielle",
  "plan.matchDay": "⚽ Jour de Match :",
  "plan.meso.backToMeso": "← Retour aux Mésocycles",
  "plan.meso.competition": "COMPÉTITION",
  "plan.meso.exportPdf": "Exporter le mois en PDF",
  "plan.meso.load": "CHARGE",
  "plan.meso.month": "MOIS",
  "plan.meso.monthDetail": "Détail du Mois : ",
  "plan.meso.predominantType": "TYPE PRÉDOMINANT",
  "plan.meso.sessions": "SÉANCES",
  "plan.meso.totalVolume": "VOLUME TOTAL",
  "plan.meso.weeks": "Semaines",
  "plan.metricSessions": "SÉANCES",
  "plan.metrics.macrocycle": "MACROCYCLE",
  "plan.metrics.mesocycle": "MÉSOCYCLE",
  "plan.metrics.mesocyclesOverview": "MÉSOCYCLES (VUE D'ENSEMBLE)",
  "plan.micro.matchDayLabel": "🏆 Jour de Match",
  "plan.micro.physical": "Physique",
  "plan.micro.rest": "Repos",
  "plan.micro.selectWeek": "SÉLECTIONNER LA SEMAINE",
  "plan.micro.sessionLabel": "Séance ({duration} min)",
  "plan.micro.tactical": "Tactique",
  "plan.micro.technical": "Technique",
  "plan.micro.week": "Semaine",
  "plan.obj.mental": "OBJECTIF MENTAL",
  "plan.obj.mentalPlaceholder": "Développer la concentration et le travail d'équipe...",
  "plan.obj.physical": "OBJECTIF PHYSIQUE",
  "plan.obj.physicalPlaceholder": "Améliorer l'endurance aérobie et la vitesse de réaction...",
  "plan.obj.seasonGeneral": "OBJECTIF GÉNÉRAL DE LA SAISON",
  "plan.obj.seasonGeneralPlaceholder": "Décrivez l'objectif principal de la saison...",
  "plan.obj.tactical": "OBJECTIF TACTIQUE",
  "plan.obj.tacticalPlaceholder": "Maîtriser le pressing haut et la relance...",
  "plan.obj.technical": "OBJECTIF TECHNIQUE",
  "plan.obj.technicalPlaceholder": "Améliorer le contrôle et la passe dans les espaces réduits...",
  "plan.pdf.error": "Erreur lors de l'exportation du PDF.",
  "plan.pdf.exported": "PDF exporté ✓",
  "plan.period.comp": "Comp",
  "plan.period.prep": "Prép",
  "plan.period.trans": "Trans",
  "plan.reschedule.body": "Le jour de match sélectionné pour cette semaine est {day}. Après confirmation, les {count} jours d'entraînement seront ajustés automatiquement pour équilibrer la charge avant le match.",
  "plan.reschedule.confirm": "Confirmer la Reprogrammation",
  "plan.reschedule.title": "Reprogrammer les jours d'entraînement ?",
  "plan.reschedule.toastSuccess": "✓ Entraînements reprogrammés selon le jour de match",
  "plan.reubicarBtn": "🔄 Reprogrammer les entraînements selon le nouveau jour",
  "plan.save": "ENREGISTRER",
  "plan.saving": "ENREGISTREMENT...",
  "plan.seasonObjective": "OBJECTIF GÉNÉRAL DE LA SAISON",
  "plan.seasonObjectivePlaceholder": "Entrez l'objectif général de la saison...",
  "plan.seasonVolume": "VOLUME DE LA SAISON",
  "plan.sessionDuration": "Durée de la séance :",
  "plan.start": "Début",
  "plan.strategicPlanning": "PLANIFICATION STRATÉGIQUE",
  "plan.tab.macrociclo": "MACROCYCLE",
  "plan.tab.mesociclo": "MÉSOCYCLE",
  "plan.tab.microciclo": "MICROCYCLE",
  "plan.tab.objetivos": "OBJECTIFS",
  "plan.totalMinutesLabel": "minutes totales",
  "plan.trainingDays": "JOURS D'ENTRAÎNEMENT",
  "plan.volumeUnit": "min/sem",
  "planning.generating_pdf": "Génération du PDF du mésocycle...",
  "planning.generating_pdf_generic": "Generando PDF...",
  "planning.login_required": "Connectez-vous pour enregistrer",
  "planning.matrix.daysPerWeek": "jours/sem",
  "planning.matrix.loadDynamics": "DYNAMIQUE DE CHARGE",
  "planning.matrix.matchDay": "JOUR DE MATCH",
  "planning.matrix.microType": "TYPE MICRO",
  "planning.matrix.microcycleNo": "N° MICROCYCLE",
  "planning.matrix.months": "MOIS",
  "planning.matrix.pctPhysical": "% PHYSIQUE",
  "planning.matrix.pctTactical": "% TACTIQUE",
  "planning.matrix.pctTechnical": "% TECHNIQUE",
  "planning.matrix.periods": "PÉRIODES",
  "planning.matrix.physicalTest": "TEST PHYSIQUE",
  "planning.matrix.savePlanning": "ENREGISTRER LA PLANIFICATION",
  "planning.matrix.sessions": "SÉANCES",
  "planning.matrix.title": "MATRICE DE PLANIFICATION",
  "planning.matrix.volumeMin": "VOLUME (MIN)",
  "planning.microType.ajuste": "Ajustement",
  "planning.microType.carga": "Charge",
  "planning.microType.choque": "Choc",
  "planning.microType.comp": "Comp",
  "planning.microType.recup": "Récup",
  "planning.pdf_error": "Erreur Exportering PDF.",
  "planning.pdf_exported": "PDF exportado ✓",
  "planning.pdf_month_not_found": "Erreur: Month Information Nont found.",
  "planning.pdf_success": "Mesocycle PDF generated Succèsfully ✓",
  "planning.save_error": "Error al enregistrer.",
  "planning.saved": "Planning enregistré ✓",
  "plans.assignModal.ageBlocked": "Non adapté à l'âge du joueur",
  "plans.assignModal.assignBtn": "Assigner le Plan",
  "plans.assignModal.frequency": "Fréquence",
  "plans.assignModal.homeAlternative": "Alternative maison",
  "plans.assignModal.minAge": "Âge min. sécurisé",
  "plans.assignModal.planName": "Nom du Plan (optionnel)",
  "plans.assignModal.preferredMaterial": "Matériel préféré",
  "plans.assignModal.reason": "Motif",
  "plans.assignModal.searchPlaceholder": "Rechercher un exercice...",
  "plans.assignModal.selectExercises": "Sélectionner des Exercices",
  "plans.assignModal.supervisionRequired": "Supervision en présentiel requise",
    "exercise.illustrationPending": "Illustration en attente — suivez la description textuelle",
  "exercise.illustrationNotice": "Protocole clinique: validation technique visuelle en cours sans génération synthétique",
  "exercise.coachingPoints": "Points clés d'exécution",
  "exercise.minSafeAge": "Âge min. sécurisé",
  "exercise.preferredMaterial": "Matériel préféré",
  "exercise.homeAlternative": "Alternative maison",
  "exercise.supervisionRequired": "Supervision en présentiel requise",
  "plans.assignModal.title": "Assigner un Plan d'Exercices",
  "plans.assignedPlan": "Programme Assigné",
  "plans.badgeIndividual": "INDIVIDUAL",
  "plans.badgeTeam": "TEAM",
  "plans.coachFeedback": "Entraîneur Instructions",
  "plans.copyLink": "COPIER LE LIEN",
  "plans.daily": "Quotidien",
  "plans.exercisesHeader": "Exercices d'Aujourd'hui",
  "plans.linkCopied": "LIEN COPIÉ !",
  "plans.loadingPlans": "Chargement Forfaits...",
  "plans.noPlansAssigned": "Le joueur has no assigned plans.",
  "plans.recommendExercises": "Recommander des Exercices",
  "plans.routinesAndPrevention": "Routines & Prevention",
  "plans.shareNotice": "Partagez ce lien avec vos joueurs afin qu'ils puissent consulter leur programme d'exercices sans se connecter :",
  "plans.sharePlan": "🔗 Compartir Plan",
  "plans.streakDays.one": "Streak: {count} day",
  "plans.streakDays.other": "Streak: {count} days",
  "player.achievements.bronzeBadge": "25 XP · Défi hebdomadaire",
  "player.achievements.completed": "Terminé !",
  "player.achievements.filterAll": "Toutes ({count})",
  "player.achievements.filterBiweekly": "Bimensuels (Argent)",
  "player.achievements.filterBronze": "Bronze ({count})",
  "player.achievements.filterGold": "Or ({count})",
  "player.achievements.filterSeason": "Saison (Or)",
  "player.achievements.filterSilver": "Argent ({count})",
  "player.achievements.filterWeekly": "Hebdomadaires (Bronze)",
  "player.achievements.goldBadge": "100 XP · Étape de Saison (Max)",
  "player.achievements.inProgress": "{percent}% terminé",
  "player.achievements.intentionOnlyNote": "(Défi d'intention)",
  "player.achievements.loading": "Chargement de la vitrine des succès...",
  "player.achievements.noSessions": "Aucune séance prévue cette semaine",
  "player.achievements.pendingActa": "Feuille de match en attente",
  "player.achievements.season": "Saison 2026-27 · Football des jeunes",
  "player.achievements.seasonPeriod": "Saison 2026-27",
  "player.achievements.silverBadge": "50 XP · Défi bimensuel",
  "player.achievements.subtabJuegos": "Jeux & Défis",
  "player.achievements.subtabRanking": "Classement",
  "player.achievements.subtabVitrina": "Vitrine",
  "player.achievements.thisFortnight": "Ces deux semaines",
  "player.achievements.thisWeek": "Cette semaine",
  "player.achievements.tierBronze": "Bronze",
  "player.achievements.tierGold": "Or",
  "player.achievements.tierSilver": "Argent",
  "player.achievements.title": "Vos Réalisations Sportives",
  "player.achievements.titleParent": "Succès de {nom}",
  "player.achievements.unlocked": "Débloqués",
  "player.achievements.xpSubtitle": "Gagnée en relevant des défis",
  "player.achievements.xpTitle": "XP de Réalisations",
  "player.addPlayer": "+ Add Joueur",
  "player.age": "Âge",
  "player.assists": "Asistencias",
  "player.attendance.absent": "Ausente",
  "player.attendance.excused": "Excusé",
  "player.attendance.injured": "Blessé",
  "player.attendance.monthlyTitle": "Monthly Attendance Record",
  "player.attendance.present": "Présent",
  "player.attendance.rate": "Annual Attendance Rate",
  "player.avgRating": "Nota Moyenne",
  "player.bmi": "IMC",
  "player.bothFeet": "Ambidextre",
  "player.cards": "Tarjetas",
  "player.category": "Catégorie",
  "player.chat.block.btn": "Yes, Block",
  "player.chat.block.confirm": "Are you sure you want à block communication avec {nom}? Neither party will be able à send private messages until unblocked.",
  "player.chat.block.success": "Utilisateur blocked Succèsfully.",
  "player.chat.block.title": "Block user?",
  "player.chat.block_error": "Erreur blocking Utilisateur.",
  "player.chat.blocked.banner": "🚫 Communication dans ce private chat is blocked.",
  "player.chat.blocked.unblockHint": "You can manage blocked users dans Profile > Privacy.",
  "player.chat.coachSender": "👑 Entraîneuring Staff",
  "player.chat.emptyDesc": "Send un message ou tap one of le quick replies above.",
  "player.chat.emptyTitle": "No messages dans ce channel yet.",
  "player.chat.headerSubtitle": "{équipe} · Private et confidential messages",
  "player.chat.headerTitle": "Direct Channel avec Coaching Staff",
  "player.chat.loading": "Chargement conversation...",
  "player.chat.menu.block": "Bloquear usuario",
  "player.chat.menu.copied": "Text copied à clipboard",
  "player.chat.menu.copy": "Copiar texto",
  "player.chat.menu.report": "Denunciar mensaje",
  "player.chat.moderation.badge": "Reportes",
  "player.chat.moderation.deleteConfirm": "Permanently supprimer ce message de le chat?",
  "player.chat.moderation.deleteMsg": "Supprimer message",
  "player.chat.moderation.empty": "No en attente reported messages.",
  "player.chat.moderation.msgDeleted": "Message supprimé de chat.",
  "player.chat.moderation.resolve": "Marcar como resuelto",
  "player.chat.moderation.resolved": "Rapport marked as resolved.",
  "player.chat.moderation.title": "Message Moderation",
  "player.chat.now": "Ahora",
  "player.chat.optionsAria": "Options du message",
  "player.chat.placeholder": "Write un message à le entraîneur...",
  "player.chat.placeholderCoach": "Write un reply à {nom}...",
  "player.chat.playerSender": "👤 Joueur",
  "player.chat.qr.coachEarly": "⏰ Remember à arrive 15 min early",
  "player.chat.qr.coachReceived": "👍 Received, see you sur le pitch",
  "player.chat.qr.coachRest": "🩺 Rest et let me know if pain persists",
  "player.chat.qr.coachSquad": "📋 Squad confirmed, all le best!",
  "player.chat.qr.discomfort": "🩺 I have muscle Courbatures",
  "player.chat.qr.late10": "🏃 Llego 10 min tarde",
  "player.chat.qr.ready": "✅ All set pour le match",
  "player.chat.qr.talk": "❓ Coach, can I speak avec you?",
  "player.chat.qr.transport": "🚗 I need transport pour le away match",
  "player.chat.quickMsg.injury": "I have un muscle discomfort et cannot train à 100%.",
  "player.chat.quickMsg.late": "I will be 5 Minutes late.",
  "player.chat.quickMsg.ready": "Ready pour ce weekend match!",
  "player.chat.quickMsg.study": "I cannot attend due à study / exam commitments.",
  "player.chat.quickReplies": "⚡ Quick replies:",
  "player.chat.quickTitle": "Quick Messages:",
  "player.chat.report.detailsPlaceholder": "Ajouter any Ajouteritional Détails (Optionnel)...",
  "player.chat.report.quotedMessage": "Rapported message:",
  "player.chat.report.reason.harassment": "Harassment, bullying ou misconduct",
  "player.chat.report.reason.inappropriate": "Inappropriate content ou offensive langue",
  "player.chat.report.reason.other": "Otro motivo",
  "player.chat.report.reason.spam": "Spam ou unwanted messages",
  "player.chat.report.selectReason": "Sélectionnez le motif :",
  "player.chat.report.submit": "Enviar Denuncia",
  "player.chat.report.submitting": "Enviando...",
  "player.chat.report.subtitle": "We review all reports à ensure un safe et respectful environment.",
  "player.chat.report.success": "Report submitted successfully. Staff will review ce message.",
  "player.chat.report.title": "Denunciar Mensaje",
  "player.chat.report_error": "Erreur Envoyering Rapport.",
  "player.chat.send": "Enviar",
  "player.chat.sendAria": "Enviar mensaje",
  "player.chat.title": "Chat with Coach",
  "player.chat.unblock.btn": "Desbloquear",
  "player.chat.unblock.confirm": "Do you want à unblock {nom} et resume messaging?",
  "player.chat.unblock.success": "Usuario desbloqueado.",
  "player.closeProfile": "Fermer profile",
  "player.coachRating": "Coach Rating",
  "player.deleteConfirm": "Êtes-vous sûr de vouloir retirer ce joueur de l'effectif ?",
  "player.deleteFromTeam": "Retirer {name} de l'Équipe",
  "player.editProfile": "Modifier Profile",
  "player.foot": "Pied dominant",
  "player.foot.both": "Ambidextre",
  "player.foot.left": "Gauche",
  "player.foot.right": "Droit",
  "player.goalAbbr": "BUT",
  "player.goals": "BUTS",
  "player.height": "Taille",
  "player.heightAbbr": "Taille",
  "player.home.almostBronze": "SUCCÈS PRESQUE DÉBLOQUÉ ! (BRONZE)",
  "player.home.almostGold": "SUCCÈS PRESQUE DÉBLOQUÉ ! (OR)",
  "player.home.almostSilver": "SUCCÈS PRESQUE DÉBLOQUÉ ! (ARGENT)",
  "player.home.announcements": "Équipe Notice Board",
  "player.home.closestAchievement": "Next Challenge",
  "player.home.goals": "MATCH GOALS",
  "player.home.goalsSub": "{goals} dans {matchs} ({minutes}')",
  "player.home.goalsSummary": "{goals} dans {matchs} ({minutes}')",
  "player.home.greeting": "Bonjour, {name} !",
  "player.home.nextChallenge": "NEXT CHALLENGE",
  "player.home.nextEventBadge": "NEXT CALL-UP",
  "player.home.nextMatch": "Next Call-up",
  "player.home.noAnnouncements": "Aucune annonce récente de l'entraîneur.",
  "player.home.noUpcoming": "Aucun entraînement programmé pour les prochains jours.",
  "player.home.rsvpBtn": "Confirmer Attendance (RSVP)",
  "player.home.rsvpPrompt": "Participerez-vous à cette séance ?",
  "player.home.scheduled": "PROGRAMADO",
  "player.home.soon": "Coming soon",
  "player.home.streak": "ATTENDANCE STREAK",
  "player.home.streakSession": "{count} consecutive séance",
  "player.home.streakSessions": "{count} consecutive séances",
  "player.home.streakSub": "{count} dans un row",
  "player.home.subtitle": "Everything set pour your next entraînement.",
  "player.home.viewDetails": "Voir Detalles",
  "player.home.viewSchedule": "Ver Calendario Completo",
  "player.leaderboard.accumulatedXP": "{xp} XP acumulados",
  "player.leaderboard.challenges": "retos",
  "player.leaderboard.colMetric": "METRIC",
  "player.leaderboard.colPlayer": "TEAMMATE",
  "player.leaderboard.colRank": "RANK",
  "player.leaderboard.colXP": "XP TOTAL",
  "player.leaderboard.footerDesc": "Commitment dans entraînement et teamwork are le path à rank up dans Mister11.",
  "player.leaderboard.footerTitle": "Every séance counts pour le équipe!",
  "player.leaderboard.leadingTeam": "👑 Leading équipe standings!",
  "player.leaderboard.matchesPlayedShort": "MP",
  "player.leaderboard.protectedData": "Protected équipe données",
  "player.leaderboard.subtitle": "Earn XP avec your entraînement attendance, minutes played et terminé challenges.",
  "player.leaderboard.tabAchievements": "Logros",
  "player.leaderboard.tabAttendance": "Présence",
  "player.leaderboard.tabGlobal": "Global XP",
  "player.leaderboard.tabMatches": "Matchs & Minutes",
  "player.leaderboard.tierTag": "Rango {tier}",
  "player.leaderboard.title": "Équipe PERFORMANCE LEADERTableau",
  "player.leaderboard.xpDiff": "Only {xp} XP away de Top #{rank}!",
  "player.leaderboard.youChip": "YOU",
  "player.leaderboard.yourRank": "Your Position:",
  "player.leftFoot": "Gaucher",
  "player.linkedAccount": "Compte Lié",
  "player.matchHistory": "Historial de Matchs",
  "player.matchHistoryEmpty": "No matchs recorded pour ce joueur.",
  "player.matches": "MATCHS",
  "player.matchesAbbr": "MJ",
  "player.minutes": "MINUTES",
  "player.minutesPlayed": "Minutes played",
  "player.nav.achievements": "Logros",
  "player.nav.chat": "Coach",
  "player.nav.home": "Accueil",
  "player.nav.profile": "Ficha",
  "player.nav.schedule": "Agenda",
  "player.nav.stats": "Stats",
  "player.nav.tests": "Tests",
  "player.noAccount": "Sans compte lié (modifier profil pour ajouter)",
  "player.noLinkedAccount": "Sans compte lié",
  "player.notifications.promptBtn": "ACTIVAR AVISOS",
  "player.notifications.promptDesc": "Instantly get official match squads et reminders two hours before each practice.",
  "player.notifications.promptLater": "Later",
  "player.notifications.promptTitle": "Would you like à turn sur squad et match alerts?",
  "player.openChat": "Open Chat avec joueur",
  "player.plans.completeExercise": "Mark as terminé",
  "player.plans.completedExercise": "Exercice completed!",
  "player.plans.error": "Error",
  "player.plans.noPlans": "Vous n'avez aucun plan actif assigné",
  "player.plans.posturalKey": "Clave Postural",
  "player.plans.prevention": "Injury Prevention",
  "player.plans.reps": "Repeticiones",
  "player.plans.rest": "Descanso",
  "player.plans.sets": "Series",
  "player.plans.stepByStep": "STEP-BY-STEP EXECUTION",
  "player.plans.subtitle": "Custom routines assigned par coaching staff",
  "player.plans.title": "Individual Entraînement Forfaits",
  "player.portal.activeCard": "Ficha activa:",
  "player.portal.family": "PORTAL FAMILIA",
  "player.portal.joinWithCode": "Rejoindre une équipe avec un code",
  "player.portal.loading": "Loading your joueur portal...",
  "player.portal.logoutAria": "Log Out ou Switch Account",
  "player.portal.myTeam": "Mon Équipe",
  "player.portal.notLinkedDesc": "You are not linked à any équipe as un joueur yet. Ask your entraîneur pour le access code ou tap below à join your squad.",
  "player.portal.notLinkedTitle": "Bonjour, {name} !",
  "player.portal.parentView": "Parent View",
  "player.portal.player": "PLAYER PORTAL",
  "player.portal.selectTeamAria": "Select joueur équipe",
  "player.portal.settingsAria": "Paramètres & Preferences",
  "player.portal.switchToCoach": "Switch à Coach Mode",
  "player.portal.themeDarkAria": "Switch à dark mode",
  "player.portal.themeLightAria": "Switch à light mode",
  "player.primaryPosition": "Poste Principal",
  "player.profile.account": "Access Account",
  "player.profile.account_deleted": "Your compte has been supprimé successfully.",
  "player.profile.activeCard": "Active Joueur:",
  "player.profile.age": "Edad",
  "player.profile.attendance": "ATTENDANCE",
  "player.profile.blockedUsers": "Usuarios Bloqueados",
  "player.profile.bmi": "BMI",
  "player.profile.bodyComp": "📊 Body Composition",
  "player.profile.bodyCompDesc": "Anthropometric parameters are monitored periodically par le coaching staff à optimize your fitness plan.",
  "player.profile.category": "Category",
  "player.profile.consentClearSign": "Borrar firma",
  "player.profile.consentDrawLabel": "Parent / Guardian Signature (touch ou mouse):",
  "player.profile.consentHealthCheck": "Health & Wellness Data: I authorize daily wellness check-ins et muscle soreness tracking solely pour injury prevention purposes.",
  "player.profile.consentModalDesc": "In accordance avec le GDPR, le parent ou legal guardian can authorize ou deny le following données processing pour le minor:",
  "player.profile.consentModalTitle": "Consentimiento Parental Digital",
  "player.profile.consentParentNameLabel": "Nom et Prénom du Parent / Tuteur *",
  "player.profile.consentPending": "En attente Signature",
  "player.profile.consentSaveSign": "Confirmer and Enregistrer Signature",
  "player.profile.consentSaving": "Enregistrement...",
  "player.profile.consentSigned": "Signed et Valid",
  "player.profile.consentStatus": "Parental Consent État",
  "player.profile.consentTestsCheck": "Tests & Performance: I authorize autonomous fitness testing (speed, jump, endurance) pour technical tracking.",
  "player.profile.consent_error": "Erreur saving consent.",
  "player.profile.consent_saved": "Parental consent updated Succèsfully.",
  "player.profile.deleteAccount": "Supprimer Account & Data (GDPR)",
  "player.profile.deleteAccountDesc": "This action is permanent et irreversible. Your user access, sports history, consents, et profil dans Mister11 will be supprimé.",
  "player.profile.deleteAccountTitle": "Supprimer your account?",
  "player.profile.deleteConfirmBtn": "Yes, Supprimer Account",
  "player.profile.deleteConfirmPrompt": "Type DELETE à confirmer:",
  "player.profile.deleteConfirmWord": "SUPPRIMER",
  "player.profile.deleteDeleting": "Eliminando...",
  "player.profile.discomfortQuestion": "2. Do you have any discomfort ou muscle pain?",
  "player.profile.discomfortZone": "Zone de gêne :",
  "player.profile.dorsal": "DORSAL",
  "player.profile.foot": "Pie dominante",
  "player.profile.general": "GENERAL",
  "player.profile.goals": "Goals",
  "player.profile.hasDiscomfort": "🟡 Tengo molestias",
  "player.profile.health": "HEALTH",
  "player.profile.height": "Altura",
  "player.profile.logout": "Cerrar Séance",
  "player.profile.matches": "Matchs",
  "player.profile.minutes": "Minutes",
  "player.profile.moodQuestion": "3. Mood et energy level today? (1 = Low, 5 = Peak)",
  "player.profile.noBlockedUsers": "You do Nont have any blocked Utilisateurs.",
  "player.profile.noDiscomfort": "🟢 Non discomfort",
  "player.profile.parentBadge": "Vista Familiar / Tutor",
  "player.profile.parent_name_required": "Please enter le parent/guardian nom.",
  "player.profile.physical": "PHYSICAL",
  "player.profile.plans": "PLANS",
  "player.profile.position": "Main Position",
  "player.profile.sendWellness": "Enregistrer Health Check-in",
  "player.profile.signConsent": "Sign / Modifier Consent",
  "player.profile.sleepQuestion": "1. Comment avez-vous dormi et récupéré ? (1 = Très mauvais, 5 = Excellent)",
  "player.profile.switchToCoach": "Switch à Coach Mode",
  "player.profile.weight": "Peso",
  "player.profile.wellnessCheckin": "DAILY Bien-être CHECK-IN",
  "player.profile.wellnessSent": "You have already submitted today's check-dans! You can mettre à jour it if your feelings change.",
  "player.profile.wellness_saved": "Wellness check-dans enregistré successfully!",
  "player.profile.years": "years old",
  "player.rightFoot": "Droitier",
  "player.schedule.attendance_error": "Erreur saving attendance.",
  "player.schedule.backToCurrentMonth": "Retour to current month",
  "player.schedule.calledBadge": "📋 Convocado",
  "player.schedule.calledUp": "Convoqué",
  "player.schedule.calledUpDesc": "Vous avez été retenu par le staff technique. Donnez 100% sur le terrain !",
  "player.schedule.coachRating": "Note du Coach :",
  "player.schedule.emptyDesc": "Your entraîneur has not scheduled séances ou matchs pour ce month yet.",
  "player.schedule.match": "MATCH",
  "player.schedule.minPlayed": "min jugados",
  "player.schedule.noEvents": "No events scheduled pour ce month.",
  "player.schedule.noMinutes": "Sans temps de jeu",
  "player.schedule.notCalled": "Not called up pour ce match",
  "player.schedule.notCalledDesc": "Gardez le cap et continuez à tout donner aux entraînements !",
  "player.schedule.pendingVerification": "En attente verification",
  "player.schedule.promptParent": "Will {nom} attend ce event?",
  "player.schedule.promptSelf": "Will you attend ce séance?",
  "player.schedule.reserve": "Standby / Reserve list",
  "player.schedule.reserveDesc": "Restez vigilant en cas de désistement de dernière minute.",
  "player.schedule.rsvpConfirmed": "Attendance confirmed: \"{état}\"",
  "player.schedule.rsvpGoing": "Going",
  "player.schedule.rsvpJustified": "Excusé",
  "player.schedule.rsvpLate": "Arriving late",
  "player.schedule.rsvpNotGoing": "Not going",
  "player.schedule.starter": "Titulaire",
  "player.schedule.substitute": "Remplaçant",
  "player.schedule.title": "Équipe Schedule",
  "player.schedule.training": "TRAINING",
  "player.settings.dangerZone": "Privacy Zone (GDPR)",
  "player.settings.deleteAccountDesc": "Permanently supprimer your profil et personal records.",
  "player.settings.installApp": "Installer l'application (PWA)",
  "player.settings.installAppDesc": "Add Mister11 à your home screen pour fast native access.",
  "player.settings.language": "Langue de l'Application",
  "player.settings.modalTitle": "Paramètres & Preferences",
  "player.settings.notifications": "Séance Reminders",
  "player.settings.notificationsDesc": "Receive reminders 1 hour before entraînement et matchs.",
  "player.settings.sessionTitle": "Séance & Account",
  "player.settings.switchModeTitle": "Rôle & Permissions",
  "player.settings.theme": "Modo Oscuro",
  "player.shareConsent": "Partager le Consentement Parental",
  "player.starter": "Titulaire",
  "player.stats.aboveAvg": "▲ +{xp} XP (Above Moyenne)",
  "player.stats.anonymousRgpd": "🔒 Anonymous données (GDPR)",
  "player.stats.areasInZero": "Areas en attente measurement",
  "player.stats.areasInZeroDesc": "Le Mental area is activated par completing questionnaires dans le Tests tab. Physical, Technical, et Tactical areas are updated avec entraîneur evaluations.",
  "player.stats.assists": "ASISTENCIAS",
  "player.stats.average": "Moyenne:",
  "player.stats.avgRating": "NOTA MEDIA",
  "player.stats.axis.attendance": "ATTENDANCE",
  "player.stats.axis.mental": "MENTAL",
  "player.stats.axis.physical": "PHYSICAL",
  "player.stats.axis.tactical": "TACTICAL",
  "player.stats.axis.technical": "TECHNICAL",
  "player.stats.belowAvg": "▼ +{xp} XP (BeFaible Moyenne)",
  "player.stats.cards": "CARDS",
  "player.stats.disciplinarySanctions": "Sanciones disciplinarias",
  "player.stats.evolutionTitle": "Test Evolution Over Time",
  "player.stats.friendlyMatch": "Amical",
  "player.stats.globalXpSubtitle": "Attendance + Minutes + achievements",
  "player.stats.globalXpTitle": "XP Global",
  "player.stats.goToTests": "Go à Questionnaires",
  "player.stats.goals": "GOALS",
  "player.stats.hideGuide": "Hide guide",
  "player.stats.hideInfo": "Ocultar info",
  "player.stats.howAxesMeasured": "How is each axis measuRouge?",
  "player.stats.howIsMeasured": "How is ce measured?",
  "player.stats.howIsMeasuredDesc": "Attendance et minutes are extracted de official match sheets dans strict compliance avec GDPR.",
  "player.stats.inCompetition": "in competition",
  "player.stats.inMatch": "dans {count} match",
  "player.stats.inMatches": "dans {count} matchs",
  "player.stats.keyPasses": "passes clés",
  "player.stats.leaderboardSubtitle": "Score et commitment dans le locker room",
  "player.stats.leaderboardTitle": "Squad LeaderTableau",
  "player.stats.makeTest": "Hacer test",
  "player.stats.matchHistory": "OFFICIAL Match HISTORY",
  "player.stats.matchHistorySync": "Synced avec entraîneur match sheets",
  "player.stats.minutesPerMatch": "Minutes per Match",
  "player.stats.minutesPlayed": "MINUTES",
  "player.stats.noAttRecorded": "● No séances recorded yet",
  "player.stats.noEvalsDesc": "Complete tests dans le Tests tab ou wait pour entraîneur assessments à see your progression charts.",
  "player.stats.noEvalsYet": "Non evaluations recorded yet",
  "player.stats.noMatchesDesc": "Your minutes, goals, et call-ups will appear here automatically after each match.",
  "player.stats.noMatchesRecorded": "● No matchs played yet",
  "player.stats.noMatchesYet": "No matchs recorded yet ce season",
  "player.stats.noTeamDataDesc": "Comparative metrics will automatically activate when entraîneur logs attendance ou matchs.",
  "player.stats.noTeamDataYet": "● Not enough squad données yet",
  "player.stats.officialMatch": "Officiel",
  "player.stats.officialMatches": "MATCHS",
  "player.stats.officialRating": "Nota Moyenne Oficial",
  "player.stats.officialSummaryTitle": "OFFICIAL STATS 2026-27",
  "player.stats.onAvg": "● +{xp} XP (On Moyenne)",
  "player.stats.pendingActaShort": "En attente Match sheet",
  "player.stats.radarAtt": "Attendance: Real attendance rate de entraînement séances et call-ups.",
  "player.stats.radarGuideTitle": "Data source pour each dimension (0 à 100):",
  "player.stats.radarLevel": "Global Niveau: {Niveau}",
  "player.stats.radarMental": "Mental: Psychological questionnaires (ACSI-28, MTQ-10), cognitive game entraînement et coaching staff rating.",
  "player.stats.radarPhys": "Physical: Fitness tests (endurance, speed, power) ou entraîneur physical grade.",
  "player.stats.radarTact": "Tactical: Positioning, decision making et game reading evaluated par entraîneur.",
  "player.stats.radarTech": "Technical: Ball control, passing, dribbling et finishing evaluated par entraîneur.",
  "player.stats.radarTitle": "SKILLS RADAR",
  "player.stats.realTime": "⚡ In real time",
  "player.stats.seasonAverage": "Season average",
  "player.stats.sourceAttendance": "Attendance: Sourced de official entraîneur entraînement logs. Grants +{xp} XP based sur your attendance rate.",
  "player.stats.sourceAverage": "Squad Average: Locker room benchmark à assess your consistency sans negative bias.",
  "player.stats.sourceInfoTitle": "Where do le données et XP points dans ce table come de?",
  "player.stats.sourceMatches": "Matchs / Minutes: Sourced from official match sheets and call-ups. Grants +{xp} XP proportional to your minutes played.",
  "player.stats.startsAndSubs": "{starts} tit. · {subs} sup.",
  "player.stats.title": "Stats & Performance",
  "player.stats.vsTeamTitle": "YOU VS Équipe Moyenne",
  "player.stats.wellnessTitle": "Bienestar Semanal (Wellness)",
  "player.stats.xpByParticipation": "+{xp} XP based sur your {pct}% participation",
  "player.stats.you": "Vous",
  "player.substitute": "Remplaçant",
  "player.syncNotice": "Goals, lineups, and minutes recorded in the Matchs module will automatically synchronize here.",
  "player.tab.attendance": "PRÉSENCE",
  "player.tab.chat": "CHAT",
  "player.tab.general": "GÉNÉRAL",
  "player.tab.health": "SANTÉ",
  "player.tab.physical": "PHYSIQUE",
  "player.tab.plans": "PROGRAMMES",
  "player.tab.settings": "PARAMÈTRES",
  "player.weight": "Poids",
  "playerDashboard.new_message": "💬 New message de Coach:",
  "playerProfile.ageLabel": "Âge",
  "playerProfile.bmi": "BMI",
  "playerProfile.bmiDesc": "Estimé Body Mass Index.",
  "playerProfile.editTooltip": "Tap à modifier your measurements",
  "playerProfile.heightLabel": "Taille",
  "playerProfile.heightRangeError": "Height must be between 100 et 230 cm.",
  "playerProfile.heightUnit": "cm",
  "playerProfile.physicalStats": "Données Physiques",
  "playerProfile.readOnlyNotice": "Age, shirt number et position can only be modified par coaching staff.",
  "playerProfile.saveError": "Erreur saving Physique stats.",
  "playerProfile.statsSaved": "Physique stats updated Succèsfully.",
  "playerProfile.weightLabel": "Peso",
  "playerProfile.weightRangeError": "Weight must be between 30 et 150 kg.",
  "playerProfile.weightUnit": "kg",
  "pos.all": "ALL",
  "pos.def": "DEF",
  "pos.del": "ST",
  "pos.ext": "W",
  "pos.ltd": "RB",
  "pos.lti": "LB",
  "pos.mc": "CM",
  "pos.mcd": "CDM",
  "pos.mco": "CAM",
  "pos.por": "GK",
  "pricing.badge.bestValueAcademies": "LE PLUS POPULAIRE CLUBS",
  "pricing.badge.mostPopularCoach": "LE PLUS CHOISI ENTRAÎNEURS",
  "pricing.billing.discountBadge": "2 MOIS GRATUITS",
  "pricing.billing.monthly": "Mensuel",
  "pricing.billing.season": "Pass Saison (10 Mois)",
  "pricing.btn.selectClubPro": "SÉLECTIONNER CLUB PRO",
  "pricing.btn.selectPremium": "SÉLECTIONNER PREMIUM",
  "pricing.btn.selectStarter": "SÉLECTIONNER STARTER",
  "pricing.btn.startFree": "COMMENCER GRATUITEMENT",
  "pricing.btn.tryPro": "ESSAYER 7 JOURS GRATUITS",
  "pricing.cancelAnytime": "Annulez à tout moment sans engagement.",
  "pricing.clubPro.attr1_strong": "Jusqu'à 15 Équipes",
  "pricing.clubPro.attr1_text": "Jusqu'à 10 membres de staff par équipe",
  "pricing.clubPro.attr2_strong": "Rapports Consolidés de Club",
  "pricing.clubPro.attr3_strong": "Historique Global de Formation et Support 24/7",
  "pricing.clubPro.vat": "~3,00 €/entraîneur/mois · TVA incluse",
  "pricing.coachPro": "Entraîneur PRO",
  "pricing.comparison.subtitle": "Analysez chaque fonctionnalité en détail entre les formules individuelles et de club avec droits vérifiés.",
  "pricing.comparison.thModule": "Module et Fonctionnalité",
  "pricing.comparison.title": "Matrice Comparative Détaillée des Fonctionnalités",
  "pricing.footer.install": "Installer l'App / PWA",
  "pricing.footer.login": "Espace Entraîneurs",
  "pricing.footer.rgpd": "RGPD et Confidentialité",
  "pricing.footer.rights": "Tous droits réservés. Palette Officielle Terre et Terrain.",
  "pricing.footer.tagline": "La plateforme d'intelligence technique pour le football de base et amateur.",
  "pricing.free.attr1_strong": "1 Équipe",
  "pricing.free.attr1_text": "(23 joueurs) · 1 Entraîneur",
  "pricing.free.attr2_strong": "10 Séances",
  "pricing.free.attr2_text": "Tableau de base · 5 IA/mois",
  "pricing.free.attr3_strong": "Signature Numérique RGPD",
  "pricing.free.attr3_text": "incluse",
  "pricing.freq.forever": "/ pour toujours",
  "pricing.freq.month": "/ mois",
  "pricing.freq.season": "/ saison",
  "pricing.freq.seasonShort": "/ sais.",
  "pricing.fullAccess": "Accès complet à toutes les fonctionnalités avancées.",
  "pricing.header.subtitle": "Prix TVA incluse. Le pass saison couvre les 10 mois de compétition officielle avec Juillet et Août offerts.",
  "pricing.header.title": "Tarifs Transparents pour Entraîneurs et Clubs",
  "pricing.monthly": "Facturation mensuelle",
  "pricing.plan.clubPremium.name": "Club Premium",
  "pricing.plan.clubPremium.tagline": "Pour académies de haute performance et multi-sites",
  "pricing.plan.clubPro.name": "Club PRO",
  "pricing.plan.clubPro.tagline": "Pour clubs structurés avec méthodologie propre",
  "pricing.plan.clubStarter.name": "Club Starter",
  "pricing.plan.clubStarter.tagline": "Pour centres de formation et clubs en développement",
  "pricing.plan.free.name": "Formule Gratuite",
  "pricing.plan.free.tagline": "Pour commencer à numériser votre équipe",
  "pricing.plan.pro.name": "Formule PRO",
  "pricing.plan.pro.tagline": "Pour l'entraîneur qui vise la performance maximale",
  "pricing.premium.attr1_strong": "Jusqu'à 40 Équipes",
  "pricing.premium.attr1_text": "Staff Illimité",
  "pricing.premium.attr2_strong": "Licences Multi-Sites et Codes",
  "pricing.premium.attr3_strong": "Accompagnement Personnalisé et Support VIP",
  "pricing.premium.vat": "TVA incluse · Support VIP",
  "pricing.pro.attr1_strong": "Jusqu'à 3 Équipes",
  "pricing.pro.attr1_text": "Séances illimitées et Live Stats",
  "pricing.pro.attr2_strong": "Feuille Officielle PDF 7 Pages",
  "pricing.pro.attr2_text": "xG-Lite (105:68) et Métriques Gardien",
  "pricing.pro.attr3_strong": "Portail Joueur",
  "pricing.pro.attr3_text": "Wellness quotidien, Tests et IA illimitée",
  "pricing.pro.vatMonthly": "Facturation mensuelle · Résiliation à tout moment",
  "pricing.pro.vatSeason": "Équivaut à 6,90 €/mois · TVA incluse",
  "pricing.starter.attr1_strong": "Jusqu'à 6 Équipes",
  "pricing.starter.attr1_text": "Jusqu'à 4 membres de staff par équipe",
  "pricing.starter.attr2_strong": "Tout ce qui est inclus dans le Plan PRO",
  "pricing.starter.attr3_strong": "Panneau Multi-Entraîneurs avec Rôles",
  "pricing.starter.vat": "~5,50 €/entraîneur/mois · TVA incluse",
  "pricing.subscribeNow": "S'abonner Maintenant",
  "pricing.vat.included": "TVA incluse",
  "push.foreground_toast": "🔔 {title} : {body}",
  "qrScanner.cameraPermissionError": "Could Nont Accès camera. Please check browser permissions.",
  "qrScanner.hint": "Point your camera à le QR code provided par le entraîneur à join le équipe automatically.",
  "qrScanner.noQrInImage": "No QR code detected dans le selected image.",
  "qrScanner.title": "Scan Équipe QR Code",
  "qrScanner.unsupportedBrowser": "Your browser ou device does not support camera access.",
  "qrScanner.uploadQrPhoto": "Upload QR photo",
  "rendimientoPdf.btnDownload": "Télécharger PDF",
  "rendimientoPdf.chartsTitle": "Joueur Metrics Comparison",
  "rendimientoPdf.generatedBy": "Generated par Mister11",
  "rendimientoPdf.matchDetails": "Détails du Match",
  "rendimientoPdf.subtitle": "Individual joueur statistics et canonical metrics",
  "rendimientoPdf.tableTitle": "Complet Performance Table",
  "rendimientoPdf.title": "INDIVIDUAL PERFORMANCE Rapport",
  "sector.activeZone": "Actif Zone: {zone}",
  "sesiones.actions.edit": "Modifier",
  "sesiones.actions.share": "Compartir",
  "sesiones.blockCount.one": "{count} Bloque",
  "sesiones.blockCount.other": "{count} Bloques",
  "sesiones.categories.all": "Todas",
  "sesiones.categories.fisica": "Physique",
  "sesiones.categories.general": "General",
  "sesiones.categories.mixta": "Mixta",
  "sesiones.categories.partido": "Match",
  "sesiones.categories.tactica": "Tactique",
  "sesiones.categories.tecnica": "Technique",
  "sesiones.clickDayToView": "Click un day à view séances",
  "sesiones.exportICS": "📅 Exporter ICS",
  "sesiones.fieldMode": "Modo Campo",
  "sesiones.importSession": "Importer Séance",
  "sesiones.newSession": "Créer une Nouvelle Séance",
  "sesiones.noDiagram": "Sin diagrama",
  "sesiones.preview.addBlock": "+ Add Block",
  "sesiones.preview.blocks": "BLOCKS",
  "sesiones.preview.deleteAnimation": "SUPPRIMER",
  "sesiones.preview.deleteSession": "Supprimer Séance",
  "sesiones.preview.editSession": "✏️ Modifier Séance",
  "sesiones.preview.emptyBlocks": "Non blocks defined.",
  "sesiones.preview.exportMp4": "🎬 EXPORTAR MP4",
  "sesiones.preview.exportPdf": "📄 Exporter to PDF",
  "sesiones.preview.generating": "⏳ Generating Rapport...",
  "sesiones.preview.googleCal": "📅 Google Cal",
  "sesiones.preview.ics": "📥 ICS",
  "sesiones.preview.load": "LOAD",
  "sesiones.preview.min": "MIN",
  "sesiones.preview.shareSession": "🔗 Share / Transfer Séance",
  "sesiones.preview.startLiveField": "⏱️ Start Live Terrain Mode (Timer & Voice)",
  "sesiones.preview.structure": "Séance Structure",
  "sesiones.preview.viewPdf": "Voir PDF",
  "sesiones.tab.animations": "Animaciones",
  "sesiones.tab.captures": "Capturas",
  "sesiones.tab.sessions": "Séances",
  "sesiones.title": "Séances d'Entraînement",
  "sesiones.views.day": "DAY",
  "sesiones.views.month": "MONTH",
  "sesiones.views.week": "WEEK",
  "session.untitled": "Sans titre",
  "sessionRating.averageRating": "Moyenne",
  "sessionRating.commentPlaceholder": "Coaching notes ou feedback (optional, max 200 chars)",
  "sessionRating.evolutionTitle": "Entraînement Evolution",
  "sessionRating.noRatings": "No ratings recorded pour ce séance yet.",
  "sessionRating.performanceTableSubtitle": "Last 5 rated séances et accumulated average",
  "sessionRating.performanceTableTitle": "Performance aux Entraînements",
  "sessionRating.radarAxisTraining": "Entraînement",
  "sessionRating.rateButton": "Calificar",
  "sessionRating.ratingLabel": "Nota",
  "sessionRating.saveError": "Error saving séance ratings.",
  "sessionRating.saveRatings": "Enregistrer Ratings",
  "sessionRating.savedSuccess": "Évaluation de séance enregistrée avec succès.",
  "sessionRating.subtitle": "Rate performance of called-up joueurs (0 à 10)",
  "sessionRating.title": "Évaluation Post-Séance (RPE)",
  "settings.teamIdentity": "Équipe Identity",
  "shot.badge_decisive": "DECISIVA",
  "shot.badge_normal": "NORMAL",
  "shot.blocked": "Tir Contré",
  "shot.cancel": "Annuler",
  "shot.comfort": "Confort du Tir",
  "shot.comfort_comfortable": "Comfortable",
  "shot.comfort_pressed": "Presionado",
  "shot.comfort_very_pressed": "Muy Presionado",
  "shot.confirm": "Registrar Tiro",
  "shot.diff_decisive": "Decisiva",
  "shot.diff_normal": "Normal",
  "shot.difficulty": "Enregistrer Difficulty",
  "shot.goal": "But Marqué",
  "shot.missed": "Tir Non Cadré",
  "shot.playType": "Play Type",
  "shot.playType_balon_parado": "Set Piece",
  "shot.playType_contra": "Contra",
  "shot.playType_jugada": "Jugada",
  "shot.playType_penalti": "Penalti",
  "shot.result": "Résultat du Tir",
  "shot.result_bloqueado": "Bloqueado",
  "shot.result_fuera": "Fuera",
  "shot.result_gol": "Gol",
  "shot.result_parada": "Enregistrer",
  "shot.saved": "Tir Cadré Arrêté",
  "shot.step1": "1. Resultado",
  "shot.step2": "2. Dificultad",
  "shot.step3": "3. Comodidad",
  "shot.team": "Équipe",
  "shot.team_own": "Propio",
  "shot.team_rival": "Rival",
  "shot.title": "Carte des Tirs",
  "shot.zone": "Shot Zone",
  "shot.zone_inside_center": "Center (Box)",
  "shot.zone_inside_left": "Left Wing (Box)",
  "shot.zone_inside_right": "Right Wing (Box)",
  "shot.zone_outside_center": "Centro (Fuera)",
  "shot.zone_outside_left": "Banda Izq. (Fuera)",
  "shot.zone_outside_right": "Banda Der. (Fuera)",
  "shot.zone_penalty": "Penalty Spot",
  "spell.addToDictionary": "Add à dictionary",
  "spell.allCorrect": "Non spelling issues",
  "spell.ignore": "Ignorar",
  "spell.missingAccent": "Falta tilde",
  "spell.noSuggestions": "Non direct suggestions",
  "spell.observations": "{count} spelling observation",
  "spell.observationsPlural": "{count} spelling observations",
  "spell.recommended": "Sugerencias:",
  "spell.title": "Spelling & Grammar",
  "spell.typo": "Typo",
  "spell.unrecognized": "Palabra no reconocida",
  "staff.cancelInvitation": "Annuler invitation",
  "staff.changeRole": "Cambiar Rol:",
  "staff.copied": "Copié !",
  "staff.copy": "Copiar",
  "staff.copyCode": "Copier le Code",
  "staff.copyLink": "Copiar Enlace",
  "staff.copyLinkDesc": "Copy et send ce link à le staff member so they can join le équipe:",
  "staff.createdDate": "Creada: {date}",
  "staff.generateLink": "⚡ Générer Lien / Code",
  "staff.inviteGenerated": "Invitation Générée !",
  "staff.inviteLinkCopied": "Lien d'invitation copié.",
  "staff.inviteModalDesc": "Enter le email address et sélectionner le role. Le user will be able à access et collaborate dans real heure.",
  "staff.inviteModalTitle": "Invite Entraîneuring Staff Member",
  "staff.inviteStaffBtn": "Invitar Staff ({count}/{limit})",
  "staff.pendingInvitations": "En attente Invitations ({count})",
  "staff.realtimeSync": "Équipe: {team} · Real-time sync",
  "staff.remove": "Quitar",
  "staff.removeConfirm": "Are you sure you want à remove {nom} de le coaching staff?",
  "staff.role.admin": "Head Entraîneur (Administrateur)",
  "staff.role.analyst": "Tactique Analyst",
  "staff.role.assistant": "Assistant / 3rd Entraîneur",
  "staff.role.assistantCoach": "Entraîneur Adjoint",
  "staff.role.coach": "Entraîneur Adjoint",
  "staff.role.collaborator": "Colaborador / Ayudante",
  "staff.role.coordinator": "Academy Director",
  "staff.role.delegate": "Équipe Delegate",
  "staff.role.doctor": "Équipe Doctor",
  "staff.role.fitness_coach": "Préparateur Physique",
  "staff.role.goalkeeperCoach": "ButGardien Entraîneur",
  "staff.role.headCoach": "Primer Entrenador",
  "staff.role.physicalTrainer": "Préparateur Physique",
  "staff.role.physio": "Kinésithérapeute",
  "staff.role.player": "Joueur",
  "staff.role.scout": "Ojeador / Scout",
  "staff.roleAssistantCoach": "Entraîneur Adjoint",
  "staff.roleDesc.admin": "Full control: équipe management, members, matchs, séances, health, et tactics.",
  "staff.roleDesc.analyst": "Real-heure Live Stats recording et analysis, reports, et analytics.",
  "staff.roleDesc.assistant": "Live Stats recording, attendance tracking, et séance support.",
  "staff.roleDesc.coach": "Match editing, lineups, séances, whiteboard, planning, et attendance.",
  "staff.roleDesc.fitness_coach": "Physical preparation, entraînement loads, fitness tests, et athletic état.",
  "staff.roleDesc.physio": "Accès et modification du dossier médical, blessures, tests physiques/wellness et présence.",
  "staff.roleDesc.player": "Accès en lecture seule à sa fiche individuelle, séances et calendrier.",
  "staff.roleDoctor": "Médecin / Soignant",
  "staff.roleFitnessCoach": "Préparateur Physique",
  "staff.roleGoalkeeperCoach": "Entraîneur des Gardiens",
  "staff.roleHeadCoach": "Entraîneur Principal",
  "staff.roleLabel": "Role dans Coaching Staff",
  "staff.rolePhysio": "Kinésithérapeute",
  "staff.roleScout": "Analyste / Recruteur",
  "staff.sendInvite": "Send Invitation",
  "staff.shareCodeDesc": "Share ce code so joueurs ou parents can join de le Portal (/join-équipe).",
  "staff.shareLink": "Compartir Enlace",
  "staff.shareNative": "📲 Compartir Enlace (WhatsApp / Apps)",
  "staff.sixDigitCode": "6-digit code:",
  "staff.staffTitle": "Entraîneuring Staff & Collaborators",
  "staff.tab.active": "Staff Actif",
  "staff.tab.invites": "Invitations",
  "staff.uniqueCodeTitle": "Unique Code for Joueurs & Families",
  "staff.you": "(You)",
  "staffHeredado.badgeActive": "PRO features actif via {ownerName}'s plan",
  "staffHeredado.badgeActiveShort": "Inherited Forfait ({ownerName})",
  "staffHeredado.gracePeriodBanner": "Subscription Notice: Le owner's plan has changed. Le équipe will enter restricted mode dans {days} days. Upgrade à PRO à maintain full access.",
  "staffHeredado.gracePeriodBlocked": "Restricted Access: Le équipe grace period has expired. Le owner must reactivate their PRO plan à restore full staff privileges.",
  "staffHeredado.restrictedFeatureStaff": "This feature requires le équipe à have un actif PRO plan de le owner.",
  "staffHeredado.transferError": "Error transferring équipe ownership.",
  "staffHeredado.transferLimitExceeded": "This user already owns un équipe sur their Free plan. They must upgrade à PRO à accept ownership of ce équipe.",
  "staffHeredado.transferSuccess": "Équipe ownership transferred successfully to {userName}.",
  "staffInvite.cardSubtitle": "Exclusive code à link assistants, fitness entraîneurs, et analysts à technical staff.",
  "staffInvite.cardTitle": "Accès CODE FOR EntraîneurES / STAFF",
  "staffInvite.codeCopied": "Staff code copied",
  "staffInvite.copyCode": "Copy Code",
  "staffInvite.copyLink": "Copiar Enlace",
  "staffInvite.downloadQr": "Télécharger QR Image",
  "staffInvite.emailLabel": "Collaborator email Ajouterress:",
  "staffInvite.inputPlaceholder": "e.g. ABC123 ou STF-ABC123",
  "staffInvite.inviteEmail": "Invite via Email",
  "staffInvite.joinBtn": "JOIN TEAM",
  "staffInvite.joinSubtitle": "If you were invited par le head entraîneur, enter your code here.",
  "staffInvite.joinTitle": "Accès CODE FOR EntraîneurES / STAFF",
  "staffInvite.linkCopied": "Staff link copied",
  "staffInvite.messageLabel": "Invitation message:",
  "staffInvite.modalTitle": "Invite Technique Staff Member",
  "staffInvite.qrCopied": "Enlace copiado",
  "staffInvite.qrModal": "Voir QR de Staff",
  "staffInvite.qrModalTitle": "Staff QR Invitation Code",
  "staffInvite.qrSubtitle": "Le invited entraîneur can scan ce QR code avec their mobile device à join le staff:",
  "staffInvite.roleLabel": "Rol asignado:",
  "staffInvite.sendBtn": "Send Invitation",
  "staffInvite.sendSuccess": "Invitation sent Succèsfully.",
  "staffInvite.shareLink": "Compartir Enlace",
  "staffJoin.assignedRole": "Rol Asignado:",
  "staffJoin.btnSubmit": "Rechercher and Join",
  "staffJoin.confirmJoin": "Confirmer AND JOIN STAFF",
  "staffJoin.errors.invalidCode": "Invalid ou expired staff code. Contact le head entraîneur.",
  "staffJoin.inputPlaceholder": "e.g. STF-ABC123 ou ABC123",
  "staffJoin.linkPlaceholder": "https://mister11.com/join-staff?code=ABC123",
  "staffJoin.orPasteLink": "Have un invite link? Paste it here:",
  "staffJoin.searching": "Validating code dans real heure...",
  "staffJoin.subtitle": "Enter le 6-character code provided par le head entraîneur ou paste your invitation link.",
  "staffJoin.success": "You have successfully joined le Technical Staff!",
  "staffJoin.teamFound": "Équipe Found:",
  "staffJoin.title": "Join Technique Staff",
  "stats.eventMap.guide": "Spatial distribution of équipe actions (recoveries, duels, shots, et fouls). Highlights where le équipe is working, winning duels, ou conceding ground sur le pitch.",
  "stats.eventMap.pass_insufficient": "Pass network unavailable: At least 5 recorded passes are required à generate tactical passing links. Showing zone event distribution instead.",
  "stats.eventMap.title": "Zone Event Map",
  "stats.passNetwork.guide": "Each node represents un joueur's average position et line thickness reflects pass volume between teammates. It identifies key passing partnerships et ball circulation dynamics.",
  "stats.theater.close": "Fermer theater mode",
  "stats.theater.exit_fullscreen": "Exit Fullscreen",
  "stats.theater.fullscreen": "Pantalla Completa",
  "stats.theater.theater_mode": "Modo Teatro",
  "status.none": "Sin Seleccionar",
  "swot.add_manual": "Ajouter manual observation",
  "swot.ai_summary_title": "Tactique Résumé (AI)",
  "swot.auto_badge": "Regla",
  "swot.btn_generate_ai": "Draft summary avec AI",
  "swot.generating_ai": "Drafting avec AI...",
  "swot.manual_badge": "Manual",
  "swot.no_items": "No observations recorded pour ce quadrant.",
  "swot.opportunities": "Opportunités Tactiques",
  "swot.origin_metric": "Origin metric",
  "swot.rule.central_box_leak": "Defensive vulnerability dans le central corridor inside own box.",
  "swot.rule.counter_efficiency": "Constant danger et rapid transitions sur counter attacks.",
  "swot.rule.duels_fragility": "Faible duel win rate compromising midTerrain posSéance control.",
  "swot.rule.duels_superiority": "Territorial dominance et authority dans individual duels.",
  "swot.rule.gk_decisive_hero": "Decisive goalkeeping performance avec high-merit crucial stops.",
  "swot.rule.gk_high_exertion": "High workload sur le goalkeeper due à frequent opponent box entries.",
  "swot.rule.high_attendance_cohesion": "Excellent entraînement attendance consistency et tactical équipe cohesion.",
  "swot.rule.high_xg_diff": "High attacking creation volume outperforming opponent dans clear chances.",
  "swot.rule.late_fatigue": "Goals ou shots conceded dans le final 15 minutes indicate fatigue.",
  "swot.rule.low_xg_conv": "Chances created avec low conversion rate, requiring finishing adjustments.",
  "swot.rule.rival_high_comfort": "Opponent shoots avec excessive comfort sans immediate pressure.",
  "swot.rule.set_piece_threat": "Chances conceded sur set pieces require tighter defensive marking.",
  "swot.rule.wing_defense_solid": "Effective control of wide channels minimizing opponent danger.",
  "swot.strengths": "Points Forts (Forces)",
  "swot.threats": "Menaces de l'Adversaire",
  "swot.title": "Matriz DAFO Trazable",
  "swot.weaknesses": "Points Faibles (Faiblesses)",
  "team.squadCount.one": "{count} joueur dans l'effectif",
  "team.squadCount.other": "{count} joueurs dans l'effectif",
  "team.title": "My Équipe",
  "teamMembers.admin_only_remove": "Only le Head Coach (Admin) can remove équipe members.",
  "teamMembers.already_member": "This user is already un member of le coaching staff.",
  "teamMembers.invite_cancelled": "Invitation Annulerled.",
  "teamMembers.invite_generated": "Invitation link et code generated successfully.",
  "teamMembers.member_removed": "Member removed de coaching staff.",
  "teamMembers.role_updated": "Role updated à {role}.",
  "teamQr.codeCopiedToast": "Équipe code copied to clipboard",
  "teamQr.copied": "Copiado",
  "teamQr.copyCode": "Copy Code",
  "teamQr.downloadImage": "Télécharger QR Image",
  "teamQr.linkCopiedToast": "Invitation link copied à clipboard",
  "teamQr.modalTitle": "Équipe QR Code and Access Link",
  "teamQr.scanInstructions": "Show ce QR code à your joueurs ou partager le direct link so they can join le équipe:",
  "teamQr.shareLink": "Compartir Enlace",
  "teamQr.teamCodeLabel": "Access Code:",
  "test.answeringAll": "Please answer Tous questionnaire items.",
  "test.auto.acsi28.cat": "Coping et Pressure",
  "test.auto.acsi28.desc": "Assesses your ability à stay calm under errors, handle pressure et focus during key match moments.",
  "test.auto.acsi28.name": "ACSI-28 (Afrontamiento Deportivo)",
  "test.auto.acsi28.q1": "I stay calm et keep un positive mindset even when le score is down.",
  "test.auto.acsi28.q2": "If I make un mistake ou lose le ball, I let it go quickly et focus sur le next play.",
  "test.auto.acsi28.q3": "I remain focused sur le game despite shouting ou outside noise.",
  "test.auto.acsi28.q4": "I can focus fully sur le tactical task requested par le head entraîneur.",
  "test.auto.acsi28.q5": "I feel total confidence dans my abilities before stepping onto le pitch.",
  "test.auto.acsi28.q6": "In crunch heure ou decisive minutes I play freely sans freezing.",
  "test.auto.acsi28.q7": "I accept entraîneur feedback knowing it helps me develop as un joueur.",
  "test.auto.acsi28.q8": "I adapt quickly if my entraîneur changes my position ou role during le game.",
  "test.auto.acsi28.short": "ACSI-28",
  "test.auto.geq.cat": "Équipe Spirit and Dressing Room",
  "test.auto.geq.desc": "Assesses squad unity, peer communication, et belonging within le squad.",
  "test.auto.geq.name": "GEQ (Groupe Environment Questionnaire)",
  "test.auto.geq.q1": "Everyone dans le dressing room pulls together toward common targets.",
  "test.auto.geq.q2": "We encourage et back each other up when someone makes un mistake.",
  "test.auto.geq.q3": "There is un healthy, positive atmosphere et true fellowship off le pitch.",
  "test.auto.geq.q4": "I feel completely valued et integrated dans ce squad.",
  "test.auto.geq.short": "GEQ Cohesion",
  "test.auto.goals.cat": "Metas y Enfoque",
  "test.auto.goals.desc": "Evaluates how you plan technical et physical goals à improve week after week.",
  "test.auto.goals.name": "But Setting Scale",
  "test.auto.goals.q1": "I clearly know which technical ou fitness skills à sharpen ce month.",
  "test.auto.goals.q2": "I give extra effort sur drills ce challenge me le most.",
  "test.auto.goals.q3": "I reflect sur matchs et drills à see what I can improve next heure.",
  "test.auto.goals.short": "Individual Buts",
  "test.auto.mhc.cat": "PsychoSocial Well-Being",
  "test.auto.mhc.desc": "Assesses joy dans playing, fulfillment, et athletic progression.",
  "test.auto.mhc.name": "MHC-SF (Bienestar Emocional)",
  "test.auto.mhc.q1": "I truly enjoy et feel happy every heure I show up à practice ou play.",
  "test.auto.mhc.q2": "I feel playing sports shapes me into un better person et builds discipline.",
  "test.auto.mhc.q3": "I enjoy un trusting et respectful relationship avec le coaching staff.",
  "test.auto.mhc.short": "Bienestar Mental",
  "test.auto.mtq10.cat": "Fortaleza Mental",
  "test.auto.mtq10.desc": "Measures your grit, determination, et how you turn challenging moments into growth opportunities.",
  "test.auto.mtq10.name": "MTQ-10 (Fortaleza y Resiliencia)",
  "test.auto.mtq10.q1": "I maintain emotional control when referee calls ou plays do not go as planned.",
  "test.auto.mtq10.q2": "I stick à workouts et physical séances even sur low-motivation days.",
  "test.auto.mtq10.q3": "I view tough opponents et challenges as chances à prove my quality.",
  "test.auto.mtq10.q4": "I trust my capability à bounce back de slumps ou bench heure.",
  "test.auto.mtq10.q5": "I never give up until le referee blows le final whistle.",
  "test.auto.mtq10.short": "Fortaleza MTQ",
  "test.auto.rpe.cat": "Physical Load et Exertion",
  "test.auto.rpe.desc": "Log your perceived exertion after your latest practice ou match using le validated Borg 1-10 scale.",
  "test.auto.rpe.name": "RPE (Escala Borg CR-10)",
  "test.auto.rpe.q1": "What level of exertion ou physical intensity did you experience dans your last séance ou match?",
  "test.auto.rpe.short": "RPE Esfuerzo",
  "test.backToCatalog": "Retour to test catalog",
  "test.category.aerobic": "Aérobie & Endurance",
  "test.category.anaerobic": "Puissance Anaérobie",
  "test.category.flexibility": "Souplesse",
  "test.category.speed": "Vitesse & Sprint",
  "test.category.strength": "Force & Puissance",
  "test.completedBadge": "Completado",
  "test.completedSuccess": "Test {name} complété avec succès ! ({pct}%)",
  "test.dim.belonging": "Pertenencia",
  "test.dim.challenge": "Challenge",
  "test.dim.coachability": "Entrenabilidad",
  "test.dim.commitment": "Compromiso",
  "test.dim.concentration": "Concentration",
  "test.dim.confidence": "Confianza",
  "test.dim.coping": "Afrontamiento",
  "test.dim.emotionalControl": "Control Emocional",
  "test.dim.goalClarity": "Goal Clarity",
  "test.dim.groupSupport": "Apoyo Grupal",
  "test.dim.perceivedEffort": "Esfuerzo Percibido",
  "test.dim.perseverance": "Perseverancia",
  "test.dim.purpose": "Purpose",
  "test.dim.selfAnalysis": "Self-Analysis",
  "test.dim.selfOvercoming": "Self-Improvement",
  "test.dim.socialCohesion": "Social Cohesion",
  "test.dim.sportsJoy": "Disfrute Deportivo",
  "test.dim.staffTrust": "Confianza Staff",
  "test.dim.taskCohesion": "Task Cohesion",
  "test.dim.underPressure": "Peak Performance under Appuyezure",
  "test.dimension": "Dimension",
  "test.errorSaving": "Erreur saving test. Please try again.",
  "test.finishAndSend": "FINALISER ET ENVOYER À L'ENTRAÎNEUR",
  "test.initialEvaluationRegistered": "Initial evaluation recorded",
  "test.lastResult": "Last result",
  "test.of": "de",
  "test.opt.agree": "Agree",
  "test.opt.almostAlways": "Casi siempre",
  "test.opt.almostNever": "Casi nunca",
  "test.opt.always": "Siempre",
  "test.opt.disagree": "Disagree",
  "test.opt.little": "Slightly agree",
  "test.opt.mostTimes": "Most of le heure",
  "test.opt.never": "Nunca",
  "test.opt.notAtAll": "Not à all agree",
  "test.opt.often": "A menudo",
  "test.opt.quite": "Moderately agree",
  "test.opt.quiteAgree": "Moderately agree",
  "test.opt.rarely": "Raras veces",
  "test.opt.rpe1": "1 - Very light (Récupération)",
  "test.opt.rpe10": "10 - Maximum effort (absolute peak)",
  "test.opt.rpe2": "2 - Light (comfortable)",
  "test.opt.rpe3": "3 - Moderate (steady aerobic)",
  "test.opt.rpe4": "4 - Somewhat hard (feeling Fatigue)",
  "test.opt.rpe5": "5 - Hard (Avisable effort)",
  "test.opt.rpe6": "6 - Bastante duro",
  "test.opt.rpe7": "7 - Very hard (Élevé Intensité)",
  "test.opt.rpe8": "8 - Très dur + (proche de la limite)",
  "test.opt.rpe9": "9 - Extenuante",
  "test.opt.sometimes": "A veces",
  "test.opt.somewhatDisagree": "Slightly agree",
  "test.opt.stronglyAgree": "Strongly agree",
  "test.opt.stronglyDisagree": "Strongly disagree",
  "test.previous": "Anterior",
  "test.question": "Pregunta",
  "test.questionProgress": "Question {current} of {Total}",
  "test.questionsCount": "{count} preguntas",
  "test.repeatTest": "Repetir Test",
  "test.retakeTest": "Repetir Cuestionario",
  "test.saveAnswers": "Enregistrer & Finish",
  "test.saving": "Enregistrement...",
  "test.startTest": "Iniciar Cuestionario",
  "test.successSaved": "Test terminé et enregistré à your file.",
  "test.tabSubtitle": "Complete ces questionnaires de your mobile à boost mindset, focus, et équipe cohesion.",
  "test.tabTitle": "Tests & Autoevaluaciones",
  "test.timeEstimate": "{minutes} min aprox.",
  "tests.alertResetConfirm": "Êtes-vous sûr de vouloir réinitialiser les données de la saison ?",
  "tests.attention": "⚠️ ATTENTION",
  "tests.catalogPhysical": "Catalogue de Tests : PHYSIQUES",
  "tests.catalogPsychosocial": "Catalogue de Tests : PSYCHOSOCIAUX",
  "tests.confirm_delete": "Confirmer deletion",
  "tests.confirm_season_reset": "Reset Season",
  "tests.createTest": "+ Créer un Test",
  "tests.demoData": "🎯 Données Démo",
  "tests.demoDataTooltip": "Insère des évaluations fictives pour prévisualiser les graphiques",
  "tests.demoSuccess": "Données de démonstration chargées avec succès !",
  "tests.error": "Error",
  "tests.exportReport": "Exporter le Rapport",
  "tests.insert_demo": "Insert demo données",
  "tests.matrix.exportTeamReport": "Exporter le Rapport Collectif",
  "tests.matrix.initialEval": "Éval Initiale",
  "tests.matrix.latestEval": "Dernière Éval",
  "tests.matrix.number": "Numéro",
  "tests.matrix.player": "Joueur",
  "tests.matrix.previousEval": "Avant-dernière Éval",
  "tests.matrix.progress": "Évolution",
  "tests.matrix.title": "MATRICE DE PLANIFICATION",
  "tests.metricUnit": "Unité : ",
  "tests.modal.cancel": "ANNULER",
  "tests.modal.confirm": "ACCEPTER",
  "tests.modal.downloadTemplate": "Télécharger le Modèle de Collecte de Données",
  "tests.modal.execution": "Exécution :",
  "tests.modal.executionProtocol": "PROTOCOLE D'EXÉCUTION",
  "tests.modal.goToRecord": "Aller à l'Enregistrement des Résultats",
  "tests.modal.measurement": "Mesure :",
  "tests.modal.noProtocol": "Aucun protocole détaillé n'a été spécifié pour ce test.",
  "tests.modal.objective": "Objectif :",
  "tests.modal.objectiveDesc": "OBJECTIF ET DESCRIPTION",
  "tests.modal.recordTitle": "Enregistrement :",
  "tests.modal.rfefBadge": "Barème Officiel RFEF (Centiles Masculin et Féminin)",
  "tests.modal.rfefTooltip": "Source : Real Federación Española de Fútbol (RFEF) - Barèmes de condition physique en football formateur féminin (Saut horizontal pieds joints).",
  "tests.modal.unit": "Unité de mesure :",
  "tests.modal.unitLabel": "Unité : ",
  "tests.newModal.category": "Catégorie Spécifique",
  "tests.newModal.categoryPlaceholder": "Ex. Endurance, Psychologie...",
  "tests.newModal.desc": "Description Courte",
  "tests.newModal.descPlaceholder": "Résumé du test",
  "tests.newModal.name": "Nom du Test",
  "tests.newModal.namePlaceholder": "Ex. 1RM Squat",
  "tests.newModal.physical": "Physique",
  "tests.newModal.protocol": "Protocole d'Exécution Complet",
  "tests.newModal.protocolPlaceholder": "Étapes exactes du déroulement du test sur le terrain...",
  "tests.newModal.psychosocial": "Psychosocial",
  "tests.newModal.socioemotional": "Socio-émotionnel",
  "tests.newModal.tactical": "Tactique",
  "tests.newModal.title": "Nouveau Test",
  "tests.newModal.type": "Type de Test",
  "tests.newModal.unit": "Unité de Mesure",
  "tests.newModal.unitPlaceholder": "Ex. kg, sec, pts",
  "tests.record": "ENREGISTRER",
  "tests.resetSeason": "🗑️ Réinitialiser la Saison",
  "tests.resetSeasonTooltip": "Supprime toutes les données d’évaluation des joueurs pour commencer une nouvelle saison",
  "tests.resources.drillDatabase": "Exercices",
  "tests.resources.myTeam": "Mi Plantilla",
  "tests.resources.seasonReport": "Season Report",
  "tests.resources.tacticalLibrary": "Tableau Tactique",
  "tests.resources.tacticalTest": "Tactical Test",
  "tests.resources.teamChat": "Équipe Chat",
  "tests.resources.title": "Ressources & Outils",
  "tests.rpe.cancel": "ANNULER",
  "tests.rpe.save": "SAVE RPE",
  "tests.saveResults": "Enregistrer Results",
  "tests.success": "Success",
  "tests.tab.comparativa": "Comparatif",
  "tests.tab.fisicos": "Tests Physiques",
  "tests.tab.historial": "Historique",
  "tests.tab.prevencion": "Prévention et Santé",
  "tests.tab.psicosociales": "Tests Psychosociaux",
  "tests.template": "MODÈLE",
  "tests.title": "ÉVALUATION & TESTS",
  "tests.validation": "Validation",
  "tests.wellness.save": "Enregistrer Evaluation",
  "wellness.fatigue": "Niveau de Fatigue",
  "wellness.mood": "Humeur / Motivation",
  "wellness.rpe.cancel": "ANNULER",
  "wellness.rpe.desc": "Record how {nom} perceived le effort.",
  "wellness.rpe.durationLabel": "Séance duration (minutes)",
  "wellness.rpe.levelLabel": "Exertion Niveau (RPE 1-10)",
  "wellness.rpe.save": "SAVE RPE",
  "wellness.rpe.scaleMax": "10 - Maximum effort",
  "wellness.rpe.scaleMin": "1 - Muy suave",
  "wellness.rpe.title": "Rate of Perceived Exertion (RPE)",
  "wellness.rpe.trainingLoad": "Entraînement Load (RPE × Durée):",
  "wellness.sleep": "Qualité du Sommeil",
  "wellness.soreness": "Douleurs Musculaires",
  "wellness.stress": "Niveau de Stress",
  "whiteboard.exportError": "Erreur Exportering MP4 video. Please try again.",
  "whiteboard.exportRetry": "Retry export",
  "whiteboard.exportSuccess": "MP4 video ExporteRouge Succèsfully.",
  "whiteboard.exportingFrame": "Exportering frame {current} of {Total}...",
  "xg.box_center": "Central Box",
  "xg.box_wings": "Lateral Box",
  "xg.decisive_pct": "Decisive Succès %",
  "xg.decisive_saves": "Paradas Decisivas",
  "xg.demanding_match": "Tarde Exigente",
  "xg.desc": "Statistical goal probability based sur zone, comfort, et play type.",
  "xg.exposure_map": "Defensive Exposure Map",
  "xg.gk_exertion": "GK Exertion Index",
  "xg.label": "Expected Goals (xG)",
  "xg.normal_match": "Exigencia Controlada",
  "xg.normal_saves": "Paradas Normales",
  "xg.outside_box": "Hors de la Surface",
  "xg.own_xg": "xG Propio",
  "xg.penalty_box": "Penalti",
  "xg.rival_comfort": "Comodidad Rival",
  "xg.rival_xg": "xG Rival",
  "xg.save_pct": "Enregistrer Effectiveness %",
  "xg.title": "xG-Lite Model & Exposure",
  "xg.totalTeam": "xG Total Équipe",
  "xg.total_saves": "Total Paradas",
  "clinical.fallbackChip": "contenu clinique en espagnol",
  "landing.footer.languages": "Langues",
  "landing.footer.rights": "Tous droits réservés.",
  "landing.hero.badge": "LE CERVEAU NUMÉRIQUE DE L'ENTRAÎNEUR",
  "landing.hero.btnPrimary": "ESSAI GRATUIT DE 7 JOURS",
  "landing.hero.btnSecondary": "VOIR LES FORFAITS ET TARIFS",
  "landing.hero.desc": "Tableau tactique interactif, enregistrement en direct aux proportions réglementaires FIFA 105:68, prévention des blessures par IA, tests psychométriques validés et rapports officiels en PDF.",
  "landing.hero.title_highlight": "niveau professionnel",
  "landing.hero.title_part1": "Portez votre méthodologie d'entraînement au",
  "landing.nav.login": "CONNEXION",
  "landing.nav.selectLang": "Sélectionner la langue",
  "landing.nav.themeToggle": "Changer de thème",
  "landing.preview.title": "Tableau Tactique Mister11 · Terrain et Jetons",
  "landing.trust.noCard": "Sans carte bancaire",
  "landing.trust.platforms": "Web, PWA et Android",
  "landing.trust.trial": "7 jours d'essai complet",
  "pricing.toggle.monthly": "Mensuel",
  "pricing.toggle.season": "Pass Saison (Recommandé)",
  "pdf.trainingSheet": "FICHE D'ENTRAÎNEMENT",
  "pdf.date": "DATE",
  "pdf.time": "HEURE",
  "pdf.duration": "DURÉE",
  "pdf.intensity": "INTENSITÉ",
  "pdf.category": "CATÉGORIE",
  "pdf.material": "MATÉRIEL",
  "pdf.blocks": "BLOCS",
  "pdf.mainTacticalDiagram": "DIAGRAMME TACTIQUE PRINCIPAL",
  "pdf.trainingBlocks": "BLOCS D'ENTRAÎNEMENT",
  "pdf.convocation": "CONVOCATION",
  "pdf.postSessionNotes": "NOTES POST-SÉANCE",
  "pdf.notesEmpty": "Aucune note enregistrée",
  "pdf.myTeam": "Mon Équipe",
  "pdf.footerBrand": "Mister11 Platform - mister11.app",
  "pdf.pageOf": "Page {cur} sur {total}",
  "pdf.objectivePrefix": "Objectif : ",
  "player.greet.hello": "Bonjour !",
  "player.join": "Rejoindre avec code",
  "player.ach.unlocked": "DÉBLOQUÉS",
  "player.tier.bronze": "Bronze",
  "player.tier.silver": "Argent",
  "player.tier.gold": "Or",
  "player.period.biweekly": "Cette quinzaine",
  "player.profile.dominantFoot": "Pied fort : {foot}",
  "player.profile.rightFoot": "Droit",
  "player.profile.leftFoot": "Gauche",
  "player.profile.ambidextrous": "Ambidextre",
  "player.consent.signEdit": "Signer / Modifier le consentement",
  "player.auth.switchToCoach": "Passer en mode entraîneur",
  "player.auth.logout": "Déconnexion",
  "player.auth.deleteAccount": "Supprimer compte et données (RGPD)",
  "player.games.healthyTraining": "ENTRAÎNEMENT SAIN",
  "player.games.homeChallenges": "Défis à domicile",
  "player.games.reactionSpeed": "VITESSE DE RÉACTION",
  "player.games.workingMemory": "MÉMOIRE DE TRAVAIL",
  "player.games.tacticalReading": "LECTURE TACTIQUE",
  "player.games.play": "JOUER",
  "player.wellness.dailyCheckin": "CHECK-IN QUOTIDIEN DE BIEN-ÊTRE",
  "player.wellness.saveCheckin": "ENVOYER LE CHECK-IN QUOTIDIEN",
  "player.wellness.updateCheckin": "METTRE À JOUR LE STATUT GÉNÉRAL",
  "player.wellness.medicalHistory": "Historique médical et blessures",
  "player.wellness.recordInjury": "ENREGISTRER DOULEUR OU BLESSURE",
  "player.plans.individualPlans": "Plans d'entraînement individuel",
  "player.plans.evolutionConstancy": "ÉVOLUTION ET RÉGULARITÉ",
  "player.plans.activeCount": "{count} Plans actifs",
  "player.plans.allUpToDate": "Tout est à jour dans vos plans !",
  "player.ach.tabs.vitrina": "Vitrine",
  "player.ach.tabs.games": "Jeux & Défis",
  "player.ach.tabs.ranking": "Classement",
  "player.schedule.prevMonth": "Mois précédent",
  "player.schedule.nextMonth": "Mois suivant",
  "player.schedule.calledUpTitle": "Convoqué pour le match !",
  "player.schedule.reserveTitle": "Liste de réserve / En attente",
  "player.schedule.notCalledTitle": "Non convoqué pour cette journée",
  "player.schedule.played": "jouées",
  "player.schedule.sheetClosed": "Feuille de match officielle clôturée",
  "player.schedule.officialMinutes": "Minutes officielles : {min}'",
  "player.schedule.dnp": "N'a pas joué lors de ce match",
  "player.schedule.parentPrompt": "{name} participera-t-il à cet événement ?",
  "player.schedule.playerPrompt": "Participerez-vous à cette séance ?",
  "player.schedule.officialRecorded": "Présence officielle enregistrée par le staff technique",
  "player.schedule.pendingVerificationDesc": "Séance effectuée, en attente de vérification par le coach",
  "player.schedule.parentTrainingPrompt": "{name} participera-t-il à cet entraînement ?",
  "player.schedule.playerTrainingPrompt": "Participerez-vous à cet entraînement ?",
  "player.schedule.photosCaptures": "Photos & Captures de l'Événement",
  "player.schedule.noEventsDesc": "Votre entraîneur n'a pas encore programmé de séances ou de matchs ce mois-ci.",
  "player.plans.active": "Actif",
  "player.plans.progressionHabit": "ÉVOLUTION ET RÉGULARITÉ",
  "player.plans.activePlan": "Plan Actif",
  "player.plans.activePlans": "Plans Actifs",
  "player.plans.youth": "Jeunes",
  "player.plans.monitoring": "Suivi",
  "player.plans.loading": "Chargement de vos plans d'entraînement...",
  "player.plans.upToDate": "Tout est à jour dans votre préparation !",
  "player.plans.techRoutine": "Routine Technique et Préventive",
  "player.plans.defaultPlanTitle": "Plan de Développement Individuel",
  "player.plans.coachInstructions": "Instructions du Coach :",
  "player.plans.todayExercises": "Exercices du Jour :",
  "player.plans.doneCount": "effectués",
  "player.plans.markPending": "Marquer comme en attente",
  "player.plans.viewGuide": "Voir le guide technique",
  "player.plans.guide": "Guide",
  "player.plans.notAgeSafe": "Non adapté à votre âge",
  "player.plans.ageSafeTooltip": "Cet exercice requiert un âge minimum de {minAge} ans pour des raisons de sécurité biomécanique.",
  "player.stats.evaluation": "Évaluation",
  "player.stats.general": "Général",
  "player.stats.session": "Séance",
  "player.stats.starter": "Titulaire",
  "player.stats.sub": "Remplaçant",
  "player.stats.pendingSheet": "En attente de feuille officielle",
  "player.stats.coachRating": "Note du Coach",
  "player.stats.attitude": "Attitude",
  "player.stats.hitsVsMisses": "Réussites vs Échecs",
  "player.stats.shotsOnTarget": "Tirs cadrés / total",
  "player.stats.duelsWon": "Duels gagnés / total",
  "player.stats.recoveriesLosses": "Récupérations vs Pertes",
  "player.stats.fouls": "fautes",
  "player.stats.bestStat": "Votre meilleure statistique ce match",
  "player.stats.youVsAverage": "Vous vs votre moyenne de saison",
  "player.stats.areasPending": "Domaines en attente d'évaluation",
  "player.stats.activeDiscomfort": "Gêne active",
  "player.stats.available100": "100% Disponible",
  "player.stats.dailyProgression": "Progression quotidienne (7 derniers check-ins)",
  "player.stats.pain": "Douleur",
  "player.stats.ok": "OK",
  "player.stats.cleanSheet": "Matchs sans but concédé",
  "player.chat.defaultPlayerName": "ce joueur",
  "player.home.defaultRole": "Joueur",
  "player.home.defaultCrack": "Champion",
  "player.home.calledUpSquad": "Vous êtes dans la convocation officielle de ce match !",
  "player.home.defaultLocation": "Terrain d'entraînement",
  "stats.singleMatch": "1 match",
  "stats.partidos": "matchs",
  "player.home.staffAuthor": "Staff Technique",
  "player.home.recent": "Récent",
  "player.banner.perfProfile": "PROFIL DE PERFORMANCE",
  "player.banner.noTestData": "Aucune évaluation pour le moment",
  "player.banner.perfMedal": "MÉDAILLE DE PERFORMANCE",
  "player.profile.securityReauth": "Pour des raisons de sécurité, vous devez vous déconnecter et vous reconnecter avant de supprimer votre compte.",
  "player.profile.deleteAccountError": "Impossible de supprimer le compte. Veuillez nous contacter ou réessayer après avoir redémarré la session.",
  "player.profile.matchesPlayedShort": "MJ",
  "player.profile.defaultCategory": "Jeunes",
  "player.profile.accountFallback": "Compte Joueur",
  "player.wellness.saving": "Enregistrement...",
  "player.consent.parentPlaceholder": "Ex. Charles Caicedo Perez",
  "player.settings.notifDenied": "Autorisations de notification refusées.",
  "player.settings.remindersActivated": "Rappels activés.",
  "player.settings.languageUpdated": "Langue mise à jour",
  "player.settings.confirmLogout": "Souhaitez-vous vous déconnecter ?",
  "player.settings.toggleTheme": "Basculer thème clair/sombre",
  "player.settings.toggleNotif": "Basculer notifications",
  "test.name.cooper": "Test de Cooper",
  "test.cat.endurance": "Physique · Endurance",
  "test.name.navette": "Course Navette",
  "test.name.sprint10": "Sprint 10m",
  "test.cat.speed": "Physique · Vitesse",
  "test.name.sprint30": "Sprint 30m",
  "test.name.ttest": "T-Test (Agilité)",
  "test.cat.agility": "Physique · Agilité",
  "test.name.cmj": "Saut CMJ",
  "test.cat.power": "Physique · Puissance",
  "test.name.cones": "Conduite de balle plots",
  "test.cat.ballControl": "Technique · Contrôle",
  "test.name.shooting": "Tir au but",
  "test.cat.accuracy": "Technique · Précision",
  "test.name.acsi28": "ACSI-28 (Faire face)",
  "test.cat.pressure": "Mental · Pression",
  "test.name.mtq10": "MTQ-10 (Force Mentale)",
  "test.cat.resilience": "Mental · Résilience",
  "test.name.goals": "Fixation d'objectifs",
  "test.cat.goals": "Mental · Objectifs",
  "test.name.leadership": "Leadership & Communication",
  "test.cat.leadership": "Mental · Leadership",
  "test.name.geq": "GEQ (Cohésion d'Équipe)",
  "test.cat.cohesion": "Social · Cohésion",
  "test.name.mhc": "Échelle Bien-être Mental",
  "test.cat.wellbeing": "Mental · Bien-être",
  "test.name.emotions": "Conscience Émotionnelle",
  "test.cat.emotions": "Mental · Émotions",
  "player.stats.pendingOfficialSheet": "En attente de confirmation officielle — Les statistiques apparaîtront dès que la feuille de match sera clôturée.",
  "stats.goles": "Buts",
  "stats.asistencias": "Passes D.",
  "stats.minutos": "Minutes",
  "player.stats.goalsThisMatch": "Buts ce match",
  "player.stats.minutesThisMatch": "Minutes ce match",
  "player.stats.avgShort": "moyenne",
  "player.stats.avgLabel": "Moyenne",
  "player.stats.coachMessage": "Message du Coach",
  "player.stats.discipline": "Discipline",
  "player.stats.lastEval": "Dernière évaluation :",
  "player.tab.technical": "Technique",
  "player.tab.tactical": "Tactique",
  "player.stats.trainingRatingDesc": "Note technique lors des séances d'entraînement",
  "player.stats.pendingRatings": "En attente d'évaluations",
  "player.stats.noRatingsYet": "Aucune évaluation d'entraînement pour le moment",
  "player.stats.ratingsInfoDesc": "Le staff technique peut évaluer les performances et consigner des notes tactiques après chaque entraînement depuis le module Séances.",
  "player.stats.weeklyWellness": "BIEN-ÊTRE ET RÉCUPÉRATION HEBDOMADAIRE",
  "player.stats.last7Days": "7 derniers jours",
  "player.stats.sleepQuality": "QUALITÉ DU SOMMEIL",
  "player.stats.energyMood": "ÉNERGIE / HUMEUR",
  "player.stats.muscleStatus": "ÉTAT MUSCULAIRE",
  "player.profile.sectionsAria": "Sections du profil du joueur",
  "player.banner.viewFullAnalytics": "Voir les analyses complètes",
  "player.banner.techSummary": "Résumé technique",
  "player.banner.renewTests": "Renouveler questionnaires et tests",
  "player.wellness.synced": "Synchronisé",
  "player.wellness.offlinePending": "En attente de synchronisation",
  "games.level.bronce": "Bronze",
  "games.level.plata": "Argent",
  "games.level.oro": "Or",
  "games.level.diamante": "Diamant",
  "games.level.leyenda": "Légende",
  "games.levelUp": "Vous êtes passé au niveau {level} ! (+10 XP)",
  "games.levelCeiling": "Vous avez atteint le sommet Légende !",
  "games.g3.opponent": "Adversaire",
  "games.g3.teammate": "Coéquipier",
  "exercise.level": "Niveau"
};

export default fr;
